import { Tag } from './tag';
import { VR } from './vr';

export class TagToVR {
    public static adjustTag(tag: number): number {
        if ((tag & 0xffe00000) === 0x50000000 || (tag & 0xffe00000) === 0x60000000) {
            return tag & 0xffe0ffff;
        }
        if ((tag & 0xff000000) === 0x7f000000 && (tag & 0xffff0000) !== 0x7fe00000) {
            return tag & 0xff00ffff;
        }
        return tag;
    }

    public static vrOf(tag: number): VR {
        if ((tag & 0x0000ffff) === 0) {
            return VR.UL; // group length
        }
        if ((tag & 0x00010000) !== 0) {
            // private creator ID
            return (tag & 0x0000ff00) === 0 && (tag & 0x000000f0) !== 0 ? VR.LO : VR.UN;
        }
        if ((tag & 0xffffff00) === Tag.SourceImageIDs) {
            return VR.CS;
        }
        const key = TagToVR.adjustTag(tag).toString(16);
        return key in TagToVR.dict ? TagToVR.dict[key] : VR.UN;
    }

    private static dict: { [key: string]: VR } = {
        '0': VR.UL,
        '2': VR.UI,
        '3': VR.UI,
        '100': VR.US,
        '110': VR.US,
        '120': VR.US,
        '600': VR.AE,
        '700': VR.US,
        '800': VR.US,
        '900': VR.US,
        '901': VR.AT,
        '902': VR.LO,
        '903': VR.US,
        '1000': VR.UI,
        '1001': VR.UI,
        '1002': VR.US,
        '1005': VR.AT,
        '1008': VR.US,
        '1020': VR.US,
        '1021': VR.US,
        '1022': VR.US,
        '1023': VR.US,
        '1030': VR.AE,
        '1031': VR.US,
        '20000': VR.UL,
        '20001': VR.OB,
        '20002': VR.UI,
        '20003': VR.UI,
        '20010': VR.UI,
        '20012': VR.UI,
        '20013': VR.SH,
        '20016': VR.AE,
        '20017': VR.AE,
        '20018': VR.AE,
        '20100': VR.UI,
        '20102': VR.OB,
        '41130': VR.CS,
        '41141': VR.CS,
        '41142': VR.CS,
        '41200': VR.UL,
        '41202': VR.UL,
        '41212': VR.US,
        '41220': VR.SQ,
        '41400': VR.UL,
        '41410': VR.US,
        '41420': VR.UL,
        '41430': VR.CS,
        '41432': VR.UI,
        '41500': VR.CS,
        '41504': VR.UL,
        '41510': VR.UI,
        '41511': VR.UI,
        '41512': VR.UI,
        '4151a': VR.UI,
        '41600': VR.UL,
        '80001': VR.UL,
        '80005': VR.CS,
        '80006': VR.SQ,
        '80008': VR.CS,
        '80010': VR.SH,
        '80012': VR.DA,
        '80013': VR.TM,
        '80014': VR.UI,
        '80015': VR.DT,
        '80016': VR.UI,
        '80018': VR.UI,
        '8001a': VR.UI,
        '8001b': VR.UI,
        '80020': VR.DA,
        '80021': VR.DA,
        '80022': VR.DA,
        '80023': VR.DA,
        '80024': VR.DA,
        '80025': VR.DA,
        '8002a': VR.DT,
        '80030': VR.TM,
        '80031': VR.TM,
        '80032': VR.TM,
        '80033': VR.TM,
        '80034': VR.TM,
        '80035': VR.TM,
        '80040': VR.US,
        '80041': VR.LO,
        '80042': VR.CS,
        '80050': VR.SH,
        '80051': VR.SQ,
        '80052': VR.CS,
        '80053': VR.CS,
        '80054': VR.AE,
        '80055': VR.AE,
        '80056': VR.CS,
        '80058': VR.UI,
        '80060': VR.CS,
        '80061': VR.CS,
        '80062': VR.UI,
        '80063': VR.SQ,
        '80064': VR.CS,
        '80068': VR.CS,
        '80070': VR.LO,
        '80080': VR.LO,
        '80081': VR.ST,
        '80082': VR.SQ,
        '80090': VR.PN,
        '80092': VR.ST,
        '80094': VR.SH,
        '80096': VR.SQ,
        '8009c': VR.PN,
        '8009d': VR.SQ,
        '80100': VR.SH,
        '80101': VR.LO,
        '80102': VR.SH,
        '80103': VR.SH,
        '80104': VR.LO,
        '80105': VR.CS,
        '80106': VR.DT,
        '80107': VR.DT,
        '80108': VR.LT,
        '80109': VR.SQ,
        '8010a': VR.CS,
        '8010b': VR.CS,
        '8010c': VR.UI,
        '8010d': VR.UI,
        '8010e': VR.UR,
        '8010f': VR.CS,
        '80110': VR.SQ,
        '80112': VR.LO,
        '80114': VR.ST,
        '80115': VR.ST,
        '80116': VR.ST,
        '80117': VR.UI,
        '80118': VR.UI,
        '80119': VR.UC,
        '80120': VR.UR,
        '80121': VR.SQ,
        '80122': VR.LO,
        '80123': VR.SQ,
        '80124': VR.SQ,
        '80201': VR.SH,
        '80220': VR.SQ,
        '80221': VR.CS,
        '80222': VR.LO,
        '80300': VR.SQ,
        '80301': VR.US,
        '80302': VR.LO,
        '80303': VR.CS,
        '80304': VR.US,
        '80305': VR.SQ,
        '80306': VR.US,
        '80307': VR.CS,
        '80308': VR.US,
        '80309': VR.UL,
        '8030a': VR.CS,
        '8030b': VR.UL,
        '8030c': VR.UC,
        '8030d': VR.UC,
        '8030e': VR.UT,
        '8030f': VR.UT,
        '80310': VR.SQ,
        '81000': VR.AE,
        '81010': VR.SH,
        '81030': VR.LO,
        '81032': VR.SQ,
        '8103e': VR.LO,
        '8103f': VR.SQ,
        '81040': VR.LO,
        '81048': VR.PN,
        '81049': VR.SQ,
        '81050': VR.PN,
        '81052': VR.SQ,
        '81060': VR.PN,
        '81062': VR.SQ,
        '81070': VR.PN,
        '81072': VR.SQ,
        '81080': VR.LO,
        '81084': VR.SQ,
        '81090': VR.LO,
        '81100': VR.SQ,
        '81110': VR.SQ,
        '81111': VR.SQ,
        '81115': VR.SQ,
        '81120': VR.SQ,
        '81125': VR.SQ,
        '81130': VR.SQ,
        '81134': VR.SQ,
        '8113a': VR.SQ,
        '81140': VR.SQ,
        '81145': VR.SQ,
        '8114a': VR.SQ,
        '8114b': VR.SQ,
        '81150': VR.UI,
        '81155': VR.UI,
        '81156': VR.SQ,
        '8115a': VR.UI,
        '81160': VR.IS,
        '81161': VR.UL,
        '81162': VR.UL,
        '81163': VR.FD,
        '81164': VR.SQ,
        '81167': VR.UI,
        '81190': VR.UR,
        '81195': VR.UI,
        '81196': VR.US,
        '81197': VR.US,
        '81198': VR.SQ,
        '81199': VR.SQ,
        '8119a': VR.SQ,
        '81200': VR.SQ,
        '81250': VR.SQ,
        '82110': VR.CS,
        '82111': VR.ST,
        '82112': VR.SQ,
        '82120': VR.SH,
        '82122': VR.IS,
        '82124': VR.IS,
        '82127': VR.SH,
        '82128': VR.IS,
        '82129': VR.IS,
        '8212a': VR.IS,
        '82130': VR.DS,
        '82132': VR.LO,
        '82133': VR.SQ,
        '82134': VR.FD,
        '82135': VR.SQ,
        '82142': VR.IS,
        '82143': VR.IS,
        '82144': VR.IS,
        '82200': VR.CS,
        '82204': VR.CS,
        '82208': VR.CS,
        '82218': VR.SQ,
        '82220': VR.SQ,
        '82228': VR.SQ,
        '82229': VR.SQ,
        '82230': VR.SQ,
        '82240': VR.SQ,
        '82242': VR.SQ,
        '82244': VR.SQ,
        '82246': VR.SQ,
        '82251': VR.SQ,
        '82253': VR.SQ,
        '82255': VR.SQ,
        '82256': VR.ST,
        '82257': VR.SQ,
        '82258': VR.ST,
        '82259': VR.SQ,
        '8225a': VR.SQ,
        '8225c': VR.SQ,
        '83001': VR.SQ,
        '83010': VR.UI,
        '83011': VR.SQ,
        '83012': VR.UI,
        '84000': VR.LT,
        '89007': VR.CS,
        '89092': VR.SQ,
        '89121': VR.SQ,
        '89123': VR.UI,
        '89124': VR.SQ,
        '89154': VR.SQ,
        '89205': VR.CS,
        '89206': VR.CS,
        '89207': VR.CS,
        '89208': VR.CS,
        '89209': VR.CS,
        '89215': VR.SQ,
        '89237': VR.SQ,
        '89410': VR.SQ,
        '89458': VR.SQ,
        '89459': VR.FL,
        '89460': VR.CS,
        '100010': VR.PN,
        '100020': VR.LO,
        '100021': VR.LO,
        '100022': VR.CS,
        '100024': VR.SQ,
        '100026': VR.SQ,
        '100027': VR.SQ,
        '100028': VR.US,
        '100030': VR.DA,
        '100032': VR.TM,
        '100033': VR.LO,
        '100034': VR.LO,
        '100035': VR.CS,
        '100040': VR.CS,
        '100050': VR.SQ,
        '100101': VR.SQ,
        '100102': VR.SQ,
        '100200': VR.CS,
        '100201': VR.SQ,
        '100212': VR.UC,
        '100213': VR.LO,
        '100214': VR.LO,
        '100215': VR.SQ,
        '100216': VR.SQ,
        '100217': VR.LO,
        '100218': VR.UT,
        '100219': VR.SQ,
        '100221': VR.SQ,
        '100222': VR.UC,
        '100223': VR.LO,
        '100229': VR.SQ,
        '101000': VR.LO,
        '101001': VR.PN,
        '101002': VR.SQ,
        '101005': VR.PN,
        '101010': VR.AS,
        '101020': VR.DS,
        '101021': VR.SQ,
        '101022': VR.DS,
        '101023': VR.DS,
        '101024': VR.DS,
        '101030': VR.DS,
        '101040': VR.LO,
        '101050': VR.LO,
        '101060': VR.PN,
        '101080': VR.LO,
        '101081': VR.LO,
        '101090': VR.LO,
        '101100': VR.SQ,
        '102000': VR.LO,
        '102110': VR.LO,
        '102150': VR.LO,
        '102152': VR.LO,
        '102154': VR.SH,
        '102155': VR.LT,
        '102160': VR.SH,
        '102180': VR.SH,
        '1021a0': VR.CS,
        '1021b0': VR.LT,
        '1021c0': VR.US,
        '1021d0': VR.DA,
        '1021f0': VR.LO,
        '102201': VR.LO,
        '102202': VR.SQ,
        '102203': VR.CS,
        '102210': VR.CS,
        '102292': VR.LO,
        '102293': VR.SQ,
        '102294': VR.SQ,
        '102295': VR.LO,
        '102296': VR.SQ,
        '102297': VR.PN,
        '102298': VR.CS,
        '102299': VR.LO,
        '104000': VR.LT,
        '109431': VR.FL,
        '120010': VR.LO,
        '120020': VR.LO,
        '120021': VR.LO,
        '120030': VR.LO,
        '120031': VR.LO,
        '120040': VR.LO,
        '120042': VR.LO,
        '120050': VR.LO,
        '120051': VR.ST,
        '120052': VR.FD,
        '120053': VR.CS,
        '120060': VR.LO,
        '120062': VR.CS,
        '120063': VR.LO,
        '120064': VR.SQ,
        '120071': VR.LO,
        '120072': VR.LO,
        '120081': VR.LO,
        '120082': VR.LO,
        '120083': VR.SQ,
        '120084': VR.CS,
        '120085': VR.CS,
        '120086': VR.DA,
        '120087': VR.DA,
        '140023': VR.ST,
        '140024': VR.ST,
        '140025': VR.ST,
        '140028': VR.ST,
        '140030': VR.DS,
        '140032': VR.DS,
        '140034': VR.DS,
        '140042': VR.ST,
        '140044': VR.ST,
        '140045': VR.ST,
        '140046': VR.LT,
        '140050': VR.CS,
        '140052': VR.CS,
        '140054': VR.DS,
        '140056': VR.DS,
        '140100': VR.LO,
        '140101': VR.CS,
        '140102': VR.DA,
        '140103': VR.TM,
        '140104': VR.PN,
        '140105': VR.ST,
        '140106': VR.SQ,
        '140107': VR.CS,
        '140108': VR.CS,
        '141010': VR.ST,
        '141020': VR.DA,
        '141040': VR.ST,
        '142002': VR.SQ,
        '142004': VR.IS,
        '142006': VR.PN,
        '142008': VR.IS,
        '142012': VR.SQ,
        '142014': VR.IS,
        '142016': VR.SH,
        '142018': VR.ST,
        '14201a': VR.CS,
        '14201c': VR.CS,
        '14201e': VR.SQ,
        '142030': VR.SQ,
        '142032': VR.SH,
        '142202': VR.IS,
        '142204': VR.SQ,
        '142206': VR.ST,
        '142208': VR.CS,
        '14220a': VR.IS,
        '14220c': VR.CS,
        '14220e': VR.CS,
        '142210': VR.OB,
        '142220': VR.SQ,
        '142222': VR.ST,
        '142224': VR.IS,
        '142226': VR.IS,
        '142228': VR.CS,
        '14222a': VR.DS,
        '14222c': VR.DS,
        '143011': VR.DS,
        '143012': VR.DS,
        '143020': VR.SQ,
        '143022': VR.ST,
        '143024': VR.DS,
        '143026': VR.DS,
        '143028': VR.DS,
        '143040': VR.SQ,
        '143050': VR.OW,
        '143060': VR.SQ,
        '143070': VR.OW,
        '143071': VR.DS,
        '143072': VR.DS,
        '143073': VR.DS,
        '143074': VR.LO,
        '143075': VR.DS,
        '143076': VR.DA,
        '143077': VR.TM,
        '143080': VR.OB,
        '143099': VR.LT,
        '144002': VR.SQ,
        '144004': VR.CS,
        '144006': VR.LT,
        '144008': VR.SQ,
        '14400a': VR.CS,
        '14400c': VR.LT,
        '14400e': VR.SQ,
        '14400f': VR.LT,
        '144010': VR.SQ,
        '144011': VR.SQ,
        '144012': VR.US,
        '144013': VR.CS,
        '144014': VR.DS,
        '144015': VR.DS,
        '144016': VR.DS,
        '144017': VR.DS,
        '144018': VR.DS,
        '144019': VR.DS,
        '14401a': VR.DS,
        '14401b': VR.DS,
        '14401c': VR.DS,
        '14401d': VR.DS,
        '144020': VR.SQ,
        '144022': VR.DS,
        '144024': VR.DS,
        '144026': VR.CS,
        '144028': VR.DS,
        '144030': VR.SQ,
        '144031': VR.DS,
        '144032': VR.CS,
        '144033': VR.IS,
        '144034': VR.DS,
        '144035': VR.SQ,
        '144036': VR.CS,
        '144038': VR.DS,
        '14403a': VR.DS,
        '14403c': VR.DS,
        '144040': VR.SQ,
        '144050': VR.SQ,
        '144051': VR.SQ,
        '144052': VR.DS,
        '144054': VR.ST,
        '144056': VR.ST,
        '144057': VR.DS,
        '144058': VR.DS,
        '144059': VR.DS,
        '14405a': VR.DS,
        '14405c': VR.ST,
        '144060': VR.SQ,
        '144062': VR.DS,
        '144064': VR.DS,
        '144070': VR.SQ,
        '144072': VR.ST,
        '144074': VR.SH,
        '144076': VR.DA,
        '144078': VR.DA,
        '14407a': VR.DA,
        '14407c': VR.TM,
        '14407e': VR.DA,
        '144080': VR.SQ,
        '144081': VR.CS,
        '144082': VR.LT,
        '144083': VR.SQ,
        '144084': VR.DS,
        '144085': VR.DS,
        '144086': VR.SQ,
        '144087': VR.SQ,
        '144088': VR.DS,
        '144089': VR.DS,
        '14408b': VR.DS,
        '14408c': VR.DS,
        '14408d': VR.DS,
        '14408e': VR.DS,
        '144091': VR.SQ,
        '144092': VR.DS,
        '14409a': VR.SQ,
        '14409b': VR.ST,
        '14409c': VR.DS,
        '14409d': VR.DS,
        '14409f': VR.DS,
        '1440a0': VR.LO,
        '1440a1': VR.LO,
        '1440a2': VR.LO,
        '145002': VR.IS,
        '145004': VR.IS,
        '145100': VR.US,
        '145101': VR.DS,
        '145102': VR.DS,
        '145103': VR.DS,
        '145104': VR.DS,
        '145105': VR.CS,
        '145106': VR.SH,
        '145107': VR.DS,
        '145108': VR.DS,
        '145109': VR.CS,
        '14510a': VR.DS,
        '14510b': VR.SH,
        '14510c': VR.DS,
        '14510d': VR.DS,
        '14510e': VR.DS,
        '14510f': VR.SH,
        '145110': VR.SH,
        '145111': VR.LO,
        '145112': VR.DS,
        '145113': VR.DS,
        '145114': VR.DS,
        '145115': VR.DS,
        '145116': VR.DS,
        '145117': VR.DS,
        '145118': VR.DS,
        '145119': VR.DS,
        '14511a': VR.DS,
        '14511b': VR.DS,
        '14511c': VR.DS,
        '14511d': VR.DS,
        '14511e': VR.CS,
        '14511f': VR.DS,
        '180010': VR.LO,
        '180012': VR.SQ,
        '180013': VR.FL,
        '180014': VR.SQ,
        '180015': VR.CS,
        '180020': VR.CS,
        '180021': VR.CS,
        '180022': VR.CS,
        '180023': VR.CS,
        '180024': VR.SH,
        '180025': VR.CS,
        '180026': VR.SQ,
        '180027': VR.TM,
        '180028': VR.DS,
        '180029': VR.SQ,
        '18002a': VR.SQ,
        '180030': VR.LO,
        '180031': VR.LO,
        '180032': VR.DS,
        '180033': VR.DS,
        '180034': VR.LO,
        '180035': VR.TM,
        '180036': VR.SQ,
        '180037': VR.CS,
        '180038': VR.CS,
        '180039': VR.CS,
        '18003a': VR.ST,
        '180040': VR.IS,
        '180042': VR.CS,
        '180050': VR.DS,
        '180060': VR.DS,
        '180070': VR.IS,
        '180071': VR.CS,
        '180072': VR.DS,
        '180073': VR.CS,
        '180074': VR.IS,
        '180075': VR.IS,
        '180080': VR.DS,
        '180081': VR.DS,
        '180082': VR.DS,
        '180083': VR.DS,
        '180084': VR.DS,
        '180085': VR.SH,
        '180086': VR.IS,
        '180087': VR.DS,
        '180088': VR.DS,
        '180089': VR.IS,
        '180090': VR.DS,
        '180091': VR.IS,
        '180093': VR.DS,
        '180094': VR.DS,
        '180095': VR.DS,
        '181000': VR.LO,
        '181002': VR.UI,
        '181003': VR.LO,
        '181004': VR.LO,
        '181005': VR.LO,
        '181006': VR.LO,
        '181007': VR.LO,
        '181008': VR.LO,
        '181009': VR.UT,
        '18100a': VR.SQ,
        '181010': VR.LO,
        '181011': VR.LO,
        '181012': VR.DA,
        '181014': VR.TM,
        '181016': VR.LO,
        '181017': VR.LO,
        '181018': VR.LO,
        '181019': VR.LO,
        '18101a': VR.LO,
        '18101b': VR.LO,
        '181020': VR.LO,
        '181022': VR.SH,
        '181023': VR.LO,
        '181030': VR.LO,
        '181040': VR.LO,
        '181041': VR.DS,
        '181042': VR.TM,
        '181043': VR.TM,
        '181044': VR.DS,
        '181045': VR.IS,
        '181046': VR.DS,
        '181047': VR.DS,
        '181048': VR.CS,
        '181049': VR.DS,
        '181050': VR.DS,
        '181060': VR.DS,
        '181061': VR.LO,
        '181062': VR.IS,
        '181063': VR.DS,
        '181064': VR.LO,
        '181065': VR.DS,
        '181066': VR.DS,
        '181067': VR.DS,
        '181068': VR.DS,
        '181069': VR.DS,
        '18106a': VR.CS,
        '18106c': VR.US,
        '18106e': VR.UL,
        '181070': VR.LO,
        '181071': VR.DS,
        '181072': VR.TM,
        '181073': VR.TM,
        '181074': VR.DS,
        '181075': VR.DS,
        '181076': VR.DS,
        '181077': VR.DS,
        '181078': VR.DT,
        '181079': VR.DT,
        '181080': VR.CS,
        '181081': VR.IS,
        '181082': VR.IS,
        '181083': VR.IS,
        '181084': VR.IS,
        '181085': VR.LO,
        '181086': VR.IS,
        '181088': VR.IS,
        '181090': VR.IS,
        '181094': VR.IS,
        '181100': VR.DS,
        '181110': VR.DS,
        '181111': VR.DS,
        '181114': VR.DS,
        '181120': VR.DS,
        '181121': VR.DS,
        '181130': VR.DS,
        '181131': VR.DS,
        '181134': VR.CS,
        '181135': VR.DS,
        '181136': VR.DS,
        '181137': VR.DS,
        '181138': VR.DS,
        '18113a': VR.CS,
        '181140': VR.CS,
        '181141': VR.DS,
        '181142': VR.DS,
        '181143': VR.DS,
        '181144': VR.DS,
        '181145': VR.DS,
        '181146': VR.DS,
        '181147': VR.CS,
        '181149': VR.IS,
        '181150': VR.IS,
        '181151': VR.IS,
        '181152': VR.IS,
        '181153': VR.IS,
        '181154': VR.DS,
        '181155': VR.CS,
        '181156': VR.CS,
        '18115a': VR.CS,
        '18115e': VR.DS,
        '181160': VR.SH,
        '181161': VR.LO,
        '181162': VR.DS,
        '181164': VR.DS,
        '181166': VR.CS,
        '181170': VR.IS,
        '181180': VR.SH,
        '181181': VR.CS,
        '181182': VR.IS,
        '181183': VR.DS,
        '181184': VR.DS,
        '181190': VR.DS,
        '181191': VR.CS,
        '1811a0': VR.DS,
        '1811a2': VR.DS,
        '1811a3': VR.DS,
        '1811a4': VR.LO,
        '1811a5': VR.DS,
        '181200': VR.DA,
        '181201': VR.TM,
        '181202': VR.DT,
        '181210': VR.SH,
        '181240': VR.IS,
        '181242': VR.IS,
        '181243': VR.IS,
        '181244': VR.US,
        '181250': VR.SH,
        '181251': VR.SH,
        '181260': VR.SH,
        '181261': VR.LO,
        '181271': VR.FD,
        '181272': VR.SQ,
        '181300': VR.DS,
        '181301': VR.CS,
        '181302': VR.IS,
        '181310': VR.US,
        '181312': VR.CS,
        '181314': VR.DS,
        '181315': VR.CS,
        '181316': VR.DS,
        '181318': VR.DS,
        '181320': VR.FL,
        '181400': VR.LO,
        '181401': VR.LO,
        '181402': VR.CS,
        '181403': VR.CS,
        '181404': VR.US,
        '181405': VR.IS,
        '181411': VR.DS,
        '181412': VR.DS,
        '181413': VR.DS,
        '181450': VR.DS,
        '181460': VR.DS,
        '181470': VR.DS,
        '181480': VR.DS,
        '181490': VR.CS,
        '181491': VR.CS,
        '181495': VR.IS,
        '181500': VR.CS,
        '181508': VR.CS,
        '181510': VR.DS,
        '181511': VR.DS,
        '181520': VR.DS,
        '181521': VR.DS,
        '181530': VR.DS,
        '181531': VR.DS,
        '181600': VR.CS,
        '181602': VR.IS,
        '181604': VR.IS,
        '181606': VR.IS,
        '181608': VR.IS,
        '181610': VR.IS,
        '181612': VR.IS,
        '181620': VR.IS,
        '181622': VR.US,
        '181623': VR.US,
        '181624': VR.US,
        '181700': VR.CS,
        '181702': VR.IS,
        '181704': VR.IS,
        '181706': VR.IS,
        '181708': VR.IS,
        '181710': VR.IS,
        '181712': VR.IS,
        '181720': VR.IS,
        '181800': VR.CS,
        '181801': VR.SH,
        '181802': VR.CS,
        '181803': VR.LO,
        '182001': VR.IS,
        '182002': VR.SH,
        '182003': VR.DS,
        '182004': VR.DS,
        '182005': VR.DS,
        '182006': VR.SH,
        '182010': VR.DS,
        '182020': VR.CS,
        '182030': VR.DS,
        '182041': VR.SQ,
        '182042': VR.UI,
        '182043': VR.FL,
        '182044': VR.FL,
        '182045': VR.SH,
        '182046': VR.FL,
        '183100': VR.CS,
        '183101': VR.DS,
        '183102': VR.DS,
        '183103': VR.IS,
        '183104': VR.IS,
        '183105': VR.IS,
        '184000': VR.LT,
        '185000': VR.SH,
        '185010': VR.LO,
        '185012': VR.DS,
        '185020': VR.LO,
        '185021': VR.LO,
        '185022': VR.DS,
        '185024': VR.DS,
        '185026': VR.DS,
        '185027': VR.DS,
        '185028': VR.DS,
        '185029': VR.DS,
        '185030': VR.DS,
        '185040': VR.DS,
        '185050': VR.IS,
        '185100': VR.CS,
        '185101': VR.CS,
        '185104': VR.SQ,
        '185210': VR.DS,
        '185212': VR.DS,
        '186000': VR.DS,
        '186011': VR.SQ,
        '186012': VR.US,
        '186014': VR.US,
        '186016': VR.UL,
        '186018': VR.UL,
        '18601a': VR.UL,
        '18601c': VR.UL,
        '18601e': VR.UL,
        '186020': VR.SL,
        '186022': VR.SL,
        '186024': VR.US,
        '186026': VR.US,
        '186028': VR.FD,
        '18602a': VR.FD,
        '18602c': VR.FD,
        '18602e': VR.FD,
        '186030': VR.UL,
        '186031': VR.CS,
        '186032': VR.UL,
        '186034': VR.FD,
        '186036': VR.FD,
        '186038': VR.UL,
        '186039': VR.SL,
        '18603a': VR.UL,
        '18603b': VR.SL,
        '18603c': VR.UL,
        '18603d': VR.SL,
        '18603e': VR.UL,
        '18603f': VR.SL,
        '186040': VR.UL,
        '186041': VR.SL,
        '186042': VR.UL,
        '186043': VR.SL,
        '186044': VR.US,
        '186046': VR.UL,
        '186048': VR.UL,
        '18604a': VR.UL,
        '18604c': VR.US,
        '18604e': VR.US,
        '186050': VR.UL,
        '186052': VR.UL,
        '186054': VR.FD,
        '186056': VR.UL,
        '186058': VR.UL,
        '18605a': VR.FL,
        '186060': VR.FL,
        '187000': VR.CS,
        '187001': VR.DS,
        '187004': VR.CS,
        '187005': VR.CS,
        '187006': VR.LT,
        '187008': VR.LT,
        '18700a': VR.SH,
        '18700c': VR.DA,
        '18700e': VR.TM,
        '187010': VR.IS,
        '187011': VR.IS,
        '187012': VR.DS,
        '187014': VR.DS,
        '187016': VR.DS,
        '18701a': VR.DS,
        '187020': VR.DS,
        '187022': VR.DS,
        '187024': VR.CS,
        '187026': VR.DS,
        '187028': VR.DS,
        '18702a': VR.LO,
        '18702b': VR.LO,
        '187030': VR.DS,
        '187032': VR.DS,
        '187034': VR.CS,
        '187036': VR.FL,
        '187038': VR.FL,
        '187040': VR.LT,
        '187041': VR.LT,
        '187042': VR.DS,
        '187044': VR.DS,
        '187046': VR.IS,
        '187048': VR.DS,
        '18704c': VR.DS,
        '187050': VR.CS,
        '187052': VR.DS,
        '187054': VR.DS,
        '187056': VR.FL,
        '187058': VR.FL,
        '187060': VR.CS,
        '187062': VR.LT,
        '187064': VR.CS,
        '187065': VR.DS,
        '188150': VR.DS,
        '188151': VR.DS,
        '189004': VR.CS,
        '189005': VR.SH,
        '189006': VR.SQ,
        '189008': VR.CS,
        '189009': VR.CS,
        '189010': VR.CS,
        '189011': VR.CS,
        '189012': VR.CS,
        '189014': VR.CS,
        '189015': VR.CS,
        '189016': VR.CS,
        '189017': VR.CS,
        '189018': VR.CS,
        '189019': VR.FD,
        '189020': VR.CS,
        '189021': VR.CS,
        '189022': VR.CS,
        '189024': VR.CS,
        '189025': VR.CS,
        '189026': VR.CS,
        '189027': VR.CS,
        '189028': VR.CS,
        '189029': VR.CS,
        '189030': VR.FD,
        '189032': VR.CS,
        '189033': VR.CS,
        '189034': VR.CS,
        '189035': VR.FD,
        '189036': VR.CS,
        '189037': VR.CS,
        '189041': VR.LO,
        '189042': VR.SQ,
        '189043': VR.CS,
        '189044': VR.CS,
        '189045': VR.SQ,
        '189046': VR.LO,
        '189047': VR.SH,
        '189048': VR.CS,
        '189049': VR.SQ,
        '189050': VR.LO,
        '189051': VR.CS,
        '189052': VR.FD,
        '189053': VR.FD,
        '189054': VR.CS,
        '189058': VR.US,
        '189059': VR.CS,
        '189060': VR.CS,
        '189061': VR.FD,
        '189062': VR.CS,
        '189063': VR.FD,
        '189064': VR.CS,
        '189065': VR.CS,
        '189066': VR.US,
        '189067': VR.CS,
        '189069': VR.FD,
        '189070': VR.FD,
        '189073': VR.FD,
        '189074': VR.DT,
        '189075': VR.CS,
        '189076': VR.SQ,
        '189077': VR.CS,
        '189078': VR.CS,
        '189079': VR.FD,
        '189080': VR.ST,
        '189081': VR.CS,
        '189082': VR.FD,
        '189083': VR.SQ,
        '189084': VR.SQ,
        '189085': VR.CS,
        '189087': VR.FD,
        '189089': VR.FD,
        '189090': VR.FD,
        '189091': VR.FD,
        '189092': VR.SQ,
        '189093': VR.US,
        '189094': VR.CS,
        '189095': VR.UL,
        '189096': VR.FD,
        '189098': VR.FD,
        '189100': VR.CS,
        '189101': VR.CS,
        '189103': VR.SQ,
        '189104': VR.FD,
        '189105': VR.FD,
        '189106': VR.FD,
        '189107': VR.SQ,
        '189112': VR.SQ,
        '189114': VR.SQ,
        '189115': VR.SQ,
        '189117': VR.SQ,
        '189118': VR.SQ,
        '189119': VR.SQ,
        '189125': VR.SQ,
        '189126': VR.SQ,
        '189127': VR.UL,
        '189147': VR.CS,
        '189151': VR.DT,
        '189152': VR.SQ,
        '189155': VR.FD,
        '189159': VR.UL,
        '189166': VR.CS,
        '189168': VR.FD,
        '189169': VR.CS,
        '189170': VR.CS,
        '189171': VR.CS,
        '189172': VR.CS,
        '189173': VR.CS,
        '189174': VR.CS,
        '189175': VR.LO,
        '189176': VR.SQ,
        '189177': VR.CS,
        '189178': VR.CS,
        '189179': VR.CS,
        '189180': VR.CS,
        '189181': VR.FD,
        '189182': VR.FD,
        '189183': VR.CS,
        '189184': VR.FD,
        '189185': VR.ST,
        '189186': VR.SH,
        '189195': VR.FD,
        '189196': VR.FD,
        '189197': VR.SQ,
        '189198': VR.CS,
        '189199': VR.CS,
        '189200': VR.CS,
        '189214': VR.CS,
        '189217': VR.FD,
        '189218': VR.FD,
        '189219': VR.SS,
        '189220': VR.FD,
        '189226': VR.SQ,
        '189227': VR.SQ,
        '189231': VR.US,
        '189232': VR.US,
        '189234': VR.UL,
        '189236': VR.CS,
        '189239': VR.SQ,
        '189240': VR.US,
        '189241': VR.US,
        '189250': VR.CS,
        '189251': VR.SQ,
        '189252': VR.LO,
        '189253': VR.US,
        '189254': VR.FD,
        '189255': VR.FD,
        '189256': VR.FD,
        '189257': VR.CS,
        '189258': VR.UL,
        '189259': VR.CS,
        '18925a': VR.FD,
        '18925b': VR.LO,
        '18925c': VR.CS,
        '18925d': VR.SQ,
        '18925e': VR.LO,
        '18925f': VR.UL,
        '189260': VR.SQ,
        '189295': VR.FD,
        '189296': VR.FD,
        '189297': VR.CS,
        '189298': VR.IS,
        '189301': VR.SQ,
        '189302': VR.CS,
        '189303': VR.FD,
        '189304': VR.SQ,
        '189305': VR.FD,
        '189306': VR.FD,
        '189307': VR.FD,
        '189308': VR.SQ,
        '189309': VR.FD,
        '189310': VR.FD,
        '189311': VR.FD,
        '189312': VR.SQ,
        '189313': VR.FD,
        '189314': VR.SQ,
        '189315': VR.CS,
        '189316': VR.CS,
        '189317': VR.FD,
        '189318': VR.FD,
        '189319': VR.FD,
        '189320': VR.SH,
        '189321': VR.SQ,
        '189322': VR.FD,
        '189323': VR.CS,
        '189324': VR.FD,
        '189325': VR.SQ,
        '189326': VR.SQ,
        '189327': VR.FD,
        '189328': VR.FD,
        '189329': VR.SQ,
        '189330': VR.FD,
        '189332': VR.FD,
        '189333': VR.CS,
        '189334': VR.CS,
        '189335': VR.FD,
        '189337': VR.US,
        '189338': VR.SQ,
        '189340': VR.SQ,
        '189341': VR.SQ,
        '189342': VR.CS,
        '189343': VR.CS,
        '189344': VR.CS,
        '189345': VR.FD,
        '189346': VR.SQ,
        '189351': VR.FL,
        '189352': VR.FL,
        '189353': VR.FL,
        '189360': VR.SQ,
        '189401': VR.SQ,
        '189402': VR.FL,
        '189403': VR.FL,
        '189404': VR.FL,
        '189405': VR.SQ,
        '189406': VR.SQ,
        '189407': VR.SQ,
        '189410': VR.CS,
        '189412': VR.SQ,
        '189417': VR.SQ,
        '189420': VR.CS,
        '189423': VR.LO,
        '189424': VR.LT,
        '189425': VR.CS,
        '189426': VR.FL,
        '189427': VR.CS,
        '189428': VR.FL,
        '189429': VR.FL,
        '189430': VR.FL,
        '189432': VR.SQ,
        '189433': VR.LO,
        '189434': VR.SQ,
        '189435': VR.CS,
        '189436': VR.SS,
        '189437': VR.SS,
        '189438': VR.SS,
        '189439': VR.SS,
        '189440': VR.SS,
        '189441': VR.US,
        '189442': VR.SS,
        '189447': VR.FL,
        '189449': VR.FL,
        '189451': VR.SQ,
        '189452': VR.FL,
        '189455': VR.SQ,
        '189456': VR.SQ,
        '189457': VR.CS,
        '189461': VR.FL,
        '189462': VR.SQ,
        '189463': VR.FL,
        '189464': VR.FL,
        '189465': VR.FL,
        '189466': VR.FL,
        '189467': VR.FL,
        '189468': VR.FL,
        '189469': VR.FL,
        '189470': VR.FL,
        '189471': VR.FL,
        '189472': VR.SQ,
        '189473': VR.FL,
        '189474': VR.CS,
        '189476': VR.SQ,
        '189477': VR.SQ,
        '189504': VR.SQ,
        '189506': VR.SQ,
        '189507': VR.SQ,
        '189508': VR.FL,
        '189509': VR.FL,
        '189510': VR.FL,
        '189511': VR.FL,
        '189514': VR.FL,
        '189515': VR.FL,
        '189516': VR.DT,
        '189517': VR.DT,
        '189518': VR.SS,
        '189519': VR.SS,
        '189524': VR.LO,
        '189525': VR.LO,
        '189526': VR.LO,
        '189527': VR.CS,
        '189528': VR.LO,
        '189530': VR.SQ,
        '189531': VR.LO,
        '189538': VR.SQ,
        '189541': VR.SQ,
        '189542': VR.SQ,
        '189543': VR.FD,
        '189544': VR.FD,
        '189545': VR.FD,
        '189546': VR.FD,
        '189547': VR.FD,
        '189548': VR.FD,
        '189549': VR.FD,
        '189550': VR.FD,
        '189551': VR.FD,
        '189552': VR.FD,
        '189553': VR.FD,
        '189554': VR.FD,
        '189555': VR.SQ,
        '189556': VR.SQ,
        '189557': VR.FD,
        '189558': VR.FD,
        '189559': VR.CS,
        '189601': VR.SQ,
        '189602': VR.FD,
        '189603': VR.FD,
        '189604': VR.FD,
        '189605': VR.FD,
        '189606': VR.FD,
        '189607': VR.FD,
        '189621': VR.SQ,
        '189622': VR.CS,
        '189623': VR.DT,
        '189624': VR.CS,
        '189701': VR.DT,
        '189715': VR.FD,
        '189716': VR.FD,
        '189717': VR.FD,
        '189718': VR.FD,
        '189719': VR.FD,
        '189720': VR.FD,
        '189721': VR.FD,
        '189722': VR.FD,
        '189723': VR.FD,
        '189724': VR.FD,
        '189725': VR.CS,
        '189726': VR.FD,
        '189727': VR.FD,
        '189729': VR.US,
        '189732': VR.SQ,
        '189733': VR.SQ,
        '189734': VR.SQ,
        '189735': VR.SQ,
        '189736': VR.SQ,
        '189737': VR.SQ,
        '189738': VR.CS,
        '189739': VR.US,
        '189740': VR.US,
        '189749': VR.SQ,
        '189751': VR.SQ,
        '189755': VR.CS,
        '189756': VR.CS,
        '189758': VR.CS,
        '189759': VR.CS,
        '189760': VR.CS,
        '189761': VR.CS,
        '189762': VR.CS,
        '189763': VR.CS,
        '189764': VR.CS,
        '189765': VR.CS,
        '189766': VR.CS,
        '189767': VR.CS,
        '189768': VR.CS,
        '189769': VR.CS,
        '189770': VR.CS,
        '189771': VR.SQ,
        '189772': VR.SQ,
        '189801': VR.FD,
        '189803': VR.SQ,
        '189804': VR.DT,
        '189805': VR.FD,
        '189806': VR.SQ,
        '189807': VR.SQ,
        '189808': VR.CS,
        '189809': VR.SQ,
        '18980b': VR.CS,
        '18980c': VR.CS,
        '18980d': VR.SQ,
        '18980e': VR.SQ,
        '18980f': VR.SQ,
        '189810': VR.SS,
        '189900': VR.LO,
        '189901': VR.UT,
        '189902': VR.SQ,
        '189903': VR.SQ,
        '189904': VR.DS,
        '189905': VR.CS,
        '189906': VR.SQ,
        '189907': VR.SQ,
        '189908': VR.UC,
        '189909': VR.SQ,
        '18990a': VR.UC,
        '18990b': VR.SQ,
        '18990c': VR.SQ,
        '18990d': VR.SQ,
        '18990e': VR.SQ,
        '18990f': VR.UT,
        '189910': VR.UT,
        '189911': VR.SQ,
        '189912': VR.SQ,
        '189913': VR.SQ,
        '189914': VR.SQ,
        '189915': VR.US,
        '189916': VR.LO,
        '189917': VR.UT,
        '189918': VR.CS,
        '189919': VR.DT,
        '18991a': VR.UT,
        '18991b': VR.SQ,
        '18991c': VR.SQ,
        '18991d': VR.SQ,
        '18991e': VR.UI,
        '18991f': VR.SQ,
        '189920': VR.SQ,
        '189921': VR.US,
        '189922': VR.LO,
        '189923': VR.UT,
        '189924': VR.UT,
        '189930': VR.CS,
        '189931': VR.SQ,
        '189932': VR.SQ,
        '189933': VR.SQ,
        '189934': VR.SQ,
        '189935': VR.SQ,
        '189936': VR.SQ,
        '189937': VR.LO,
        '189938': VR.US,
        '189939': VR.US,
        '18993a': VR.US,
        '18993b': VR.SQ,
        '18993c': VR.SQ,
        '18993d': VR.SQ,
        '18993e': VR.SQ,
        '189941': VR.UT,
        '189942': VR.FD,
        '189943': VR.FD,
        '189944': VR.CS,
        '189945': VR.FD,
        '189946': VR.FD,
        '189947': VR.CS,
        '18a001': VR.SQ,
        '18a002': VR.DT,
        '18a003': VR.ST,
        '20000d': VR.UI,
        '20000e': VR.UI,
        '200010': VR.SH,
        '200011': VR.IS,
        '200012': VR.IS,
        '200013': VR.IS,
        '200014': VR.IS,
        '200015': VR.IS,
        '200016': VR.IS,
        '200017': VR.IS,
        '200018': VR.IS,
        '200019': VR.IS,
        '200020': VR.CS,
        '200022': VR.IS,
        '200024': VR.IS,
        '200026': VR.IS,
        '200030': VR.DS,
        '200032': VR.DS,
        '200035': VR.DS,
        '200037': VR.DS,
        '200050': VR.DS,
        '200052': VR.UI,
        '200060': VR.CS,
        '200062': VR.CS,
        '200070': VR.LO,
        '200080': VR.CS,
        '2000aa': VR.IS,
        '200100': VR.IS,
        '200105': VR.IS,
        '200110': VR.DS,
        '200200': VR.UI,
        '200242': VR.UI,
        '201000': VR.IS,
        '201001': VR.IS,
        '201002': VR.IS,
        '201003': VR.IS,
        '201004': VR.IS,
        '201005': VR.IS,
        '201020': VR.LO,
        '20103f': VR.LO,
        '201040': VR.LO,
        '201041': VR.DS,
        '201070': VR.IS,
        '201200': VR.IS,
        '201202': VR.IS,
        '201204': VR.IS,
        '201206': VR.IS,
        '201208': VR.IS,
        '201209': VR.IS,
        '203100': VR.CS,
        '203401': VR.CS,
        '203402': VR.CS,
        '203403': VR.DA,
        '203404': VR.LO,
        '203405': VR.TM,
        '203406': VR.LO,
        '204000': VR.LT,
        '205000': VR.AT,
        '205002': VR.LO,
        '209056': VR.SH,
        '209057': VR.UL,
        '209071': VR.SQ,
        '209072': VR.CS,
        '209111': VR.SQ,
        '209113': VR.SQ,
        '209116': VR.SQ,
        '209128': VR.UL,
        '209153': VR.FD,
        '209154': VR.FL,
        '209155': VR.FL,
        '209156': VR.US,
        '209157': VR.UL,
        '209158': VR.LT,
        '209161': VR.UI,
        '209162': VR.US,
        '209163': VR.US,
        '209164': VR.UI,
        '209165': VR.AT,
        '209167': VR.AT,
        '209170': VR.SQ,
        '209171': VR.SQ,
        '209172': VR.SQ,
        '209213': VR.LO,
        '209221': VR.SQ,
        '209222': VR.SQ,
        '209228': VR.UL,
        '209238': VR.LO,
        '209241': VR.FL,
        '209245': VR.FL,
        '209246': VR.FL,
        '209247': VR.CS,
        '209248': VR.FL,
        '209249': VR.CS,
        '209250': VR.CS,
        '209251': VR.FD,
        '209252': VR.FD,
        '209253': VR.SQ,
        '209254': VR.FD,
        '209255': VR.FD,
        '209256': VR.FD,
        '209257': VR.FD,
        '209301': VR.FD,
        '209302': VR.FD,
        '209307': VR.CS,
        '209308': VR.FD,
        '209309': VR.FD,
        '20930a': VR.FD,
        '20930b': VR.CS,
        '20930c': VR.CS,
        '20930d': VR.FD,
        '20930e': VR.SQ,
        '20930f': VR.SQ,
        '209310': VR.SQ,
        '209311': VR.CS,
        '209312': VR.UI,
        '209313': VR.UI,
        '209421': VR.LO,
        '209450': VR.SQ,
        '209453': VR.LO,
        '209518': VR.US,
        '209529': VR.SQ,
        '209536': VR.US,
        '220001': VR.US,
        '220002': VR.US,
        '220003': VR.US,
        '220004': VR.US,
        '220005': VR.CS,
        '220006': VR.SQ,
        '220007': VR.FL,
        '220008': VR.FL,
        '220009': VR.FL,
        '22000a': VR.FL,
        '22000b': VR.FL,
        '22000c': VR.FL,
        '22000d': VR.CS,
        '22000e': VR.FL,
        '220010': VR.FL,
        '220011': VR.FL,
        '220012': VR.FL,
        '220013': VR.FL,
        '220014': VR.FL,
        '220015': VR.SQ,
        '220016': VR.SQ,
        '220017': VR.SQ,
        '220018': VR.SQ,
        '220019': VR.SQ,
        '22001a': VR.SQ,
        '22001b': VR.SQ,
        '22001c': VR.SQ,
        '22001d': VR.SQ,
        '22001e': VR.FL,
        '220020': VR.SQ,
        '220021': VR.SQ,
        '220022': VR.SQ,
        '220028': VR.CS,
        '220030': VR.FL,
        '220031': VR.SQ,
        '220032': VR.FL,
        '220035': VR.FL,
        '220036': VR.FL,
        '220037': VR.FL,
        '220038': VR.FL,
        '220039': VR.CS,
        '220041': VR.FL,
        '220042': VR.SQ,
        '220048': VR.FL,
        '220049': VR.FL,
        '22004e': VR.DS,
        '220055': VR.FL,
        '220056': VR.FL,
        '220057': VR.FL,
        '220058': VR.SQ,
        '221007': VR.SQ,
        '221008': VR.SQ,
        '221009': VR.CS,
        '221010': VR.CS,
        '221012': VR.SQ,
        '221019': VR.FL,
        '221024': VR.SQ,
        '221025': VR.SQ,
        '221028': VR.SQ,
        '221029': VR.LO,
        '221033': VR.FL,
        '221035': VR.SQ,
        '221037': VR.FL,
        '221039': VR.CS,
        '221040': VR.SQ,
        '221044': VR.SQ,
        '221050': VR.SQ,
        '221053': VR.FL,
        '221054': VR.FL,
        '221059': VR.FL,
        '221065': VR.LO,
        '221066': VR.LO,
        '221090': VR.SQ,
        '221092': VR.SQ,
        '221093': VR.LO,
        '221094': VR.LO,
        '221095': VR.LO,
        '221096': VR.SQ,
        '221097': VR.LO,
        '221100': VR.SQ,
        '221101': VR.SQ,
        '221103': VR.SQ,
        '221121': VR.FL,
        '221122': VR.FL,
        '221125': VR.SQ,
        '221127': VR.SQ,
        '221128': VR.SQ,
        '221130': VR.FL,
        '221131': VR.FL,
        '221132': VR.SQ,
        '221133': VR.SQ,
        '221134': VR.SQ,
        '221135': VR.SQ,
        '221140': VR.CS,
        '221150': VR.SQ,
        '221153': VR.SQ,
        '221155': VR.FL,
        '221159': VR.LO,
        '221210': VR.SQ,
        '221211': VR.SQ,
        '221212': VR.SQ,
        '221220': VR.SQ,
        '221225': VR.SQ,
        '221230': VR.SQ,
        '221250': VR.SQ,
        '221255': VR.SQ,
        '221257': VR.SQ,
        '221260': VR.SQ,
        '221262': VR.SQ,
        '221265': VR.SQ,
        '221273': VR.LO,
        '221300': VR.SQ,
        '221310': VR.SQ,
        '221330': VR.SQ,
        '221415': VR.CS,
        '221420': VR.SQ,
        '221423': VR.SQ,
        '221436': VR.SQ,
        '221443': VR.SQ,
        '221445': VR.SQ,
        '221450': VR.SQ,
        '221452': VR.SS,
        '221454': VR.LO,
        '221458': VR.SQ,
        '221460': VR.FL,
        '221463': VR.FL,
        '221465': VR.SQ,
        '221466': VR.CS,
        '221467': VR.FL,
        '221468': VR.FL,
        '221470': VR.SQ,
        '221472': VR.SQ,
        '221512': VR.SQ,
        '221513': VR.SQ,
        '221515': VR.CS,
        '221517': VR.FL,
        '221518': VR.SQ,
        '221525': VR.SQ,
        '221526': VR.SQ,
        '221527': VR.FL,
        '221528': VR.FL,
        '221529': VR.FL,
        '221530': VR.UL,
        '221531': VR.OF,
        '221612': VR.SQ,
        '221615': VR.SQ,
        '221616': VR.LO,
        '221618': VR.SQ,
        '221620': VR.SQ,
        '221622': VR.CS,
        '221624': VR.FL,
        '221626': VR.FL,
        '221628': VR.SQ,
        '221630': VR.DS,
        '221640': VR.SQ,
        '221642': VR.UL,
        '221643': VR.FL,
        '221644': VR.FL,
        '221645': VR.FL,
        '221646': VR.FL,
        '221649': VR.FL,
        '221650': VR.FL,
        '221658': VR.UL,
        '240010': VR.FL,
        '240011': VR.FL,
        '240012': VR.CS,
        '240016': VR.SQ,
        '240018': VR.FL,
        '240020': VR.FL,
        '240021': VR.SQ,
        '240024': VR.SQ,
        '240025': VR.FL,
        '240028': VR.FL,
        '240032': VR.SQ,
        '240033': VR.SQ,
        '240034': VR.SQ,
        '240035': VR.US,
        '240036': VR.US,
        '240037': VR.CS,
        '240038': VR.US,
        '240039': VR.CS,
        '240040': VR.CS,
        '240042': VR.US,
        '240044': VR.LT,
        '240045': VR.CS,
        '240046': VR.FL,
        '240048': VR.US,
        '240050': VR.US,
        '240051': VR.CS,
        '240052': VR.CS,
        '240053': VR.CS,
        '240054': VR.FL,
        '240055': VR.CS,
        '240056': VR.US,
        '240057': VR.CS,
        '240058': VR.SQ,
        '240059': VR.CS,
        '240060': VR.US,
        '240061': VR.CS,
        '240062': VR.CS,
        '240063': VR.CS,
        '240064': VR.SQ,
        '240065': VR.SQ,
        '240066': VR.FL,
        '240067': VR.SQ,
        '240068': VR.FL,
        '240069': VR.LO,
        '240070': VR.FL,
        '240071': VR.FL,
        '240072': VR.CS,
        '240073': VR.FL,
        '240074': VR.CS,
        '240075': VR.FL,
        '240076': VR.CS,
        '240077': VR.FL,
        '240078': VR.CS,
        '240079': VR.FL,
        '240080': VR.CS,
        '240081': VR.FL,
        '240083': VR.SQ,
        '240085': VR.SQ,
        '240086': VR.CS,
        '240087': VR.FL,
        '240088': VR.FL,
        '240089': VR.SQ,
        '240090': VR.FL,
        '240091': VR.FL,
        '240092': VR.FL,
        '240093': VR.CS,
        '240094': VR.FL,
        '240095': VR.CS,
        '240096': VR.FL,
        '240097': VR.SQ,
        '240098': VR.FL,
        '240100': VR.FL,
        '240102': VR.CS,
        '240103': VR.FL,
        '240104': VR.FL,
        '240105': VR.FL,
        '240106': VR.CS,
        '240107': VR.FL,
        '240108': VR.FL,
        '240110': VR.SQ,
        '240112': VR.SQ,
        '240113': VR.CS,
        '240114': VR.SQ,
        '240115': VR.SQ,
        '240117': VR.CS,
        '240118': VR.FL,
        '240120': VR.CS,
        '240122': VR.SQ,
        '240124': VR.CS,
        '240126': VR.FL,
        '240202': VR.LO,
        '240306': VR.LO,
        '240307': VR.LO,
        '240308': VR.LO,
        '240309': VR.LO,
        '240317': VR.SQ,
        '240320': VR.SQ,
        '240325': VR.SQ,
        '240338': VR.CS,
        '240341': VR.FL,
        '240344': VR.SQ,
        '280002': VR.US,
        '280003': VR.US,
        '280004': VR.CS,
        '280005': VR.US,
        '280006': VR.US,
        '280008': VR.IS,
        '280009': VR.AT,
        '28000a': VR.AT,
        '280010': VR.US,
        '280011': VR.US,
        '280012': VR.US,
        '280014': VR.US,
        '280030': VR.DS,
        '280031': VR.DS,
        '280032': VR.DS,
        '280034': VR.IS,
        '280040': VR.CS,
        '280050': VR.LO,
        '280051': VR.CS,
        '28005f': VR.LO,
        '280060': VR.CS,
        '280061': VR.SH,
        '280062': VR.LO,
        '280063': VR.SH,
        '280065': VR.CS,
        '280066': VR.AT,
        '280068': VR.US,
        '280069': VR.US,
        '280070': VR.US,
        '280071': VR.SS,
        '280080': VR.US,
        '280081': VR.US,
        '280082': VR.US,
        '280090': VR.CS,
        '280091': VR.US,
        '280092': VR.US,
        '280093': VR.US,
        '280094': VR.US,
        '280100': VR.US,
        '280101': VR.US,
        '280102': VR.US,
        '280103': VR.US,
        '280104': VR.SS,
        '280105': VR.SS,
        '280106': VR.SS,
        '280107': VR.SS,
        '280108': VR.SS,
        '280109': VR.SS,
        '280110': VR.SS,
        '280111': VR.SS,
        '280120': VR.SS,
        '280121': VR.SS,
        '280122': VR.FL,
        '280123': VR.FD,
        '280124': VR.FL,
        '280125': VR.FD,
        '280200': VR.US,
        '280300': VR.CS,
        '280301': VR.CS,
        '280302': VR.CS,
        '280303': VR.CS,
        '280304': VR.UI,
        '280400': VR.LO,
        '280401': VR.LO,
        '280402': VR.US,
        '280403': VR.LO,
        '280404': VR.AT,
        '280700': VR.LO,
        '280701': VR.CS,
        '280702': VR.AT,
        '280710': VR.US,
        '280720': VR.US,
        '280721': VR.AT,
        '280722': VR.US,
        '280730': VR.US,
        '280740': VR.US,
        '280800': VR.CS,
        '280802': VR.US,
        '280803': VR.AT,
        '280804': VR.US,
        '280808': VR.AT,
        '280a02': VR.CS,
        '280a04': VR.LO,
        '281040': VR.CS,
        '281041': VR.SS,
        '281050': VR.DS,
        '281051': VR.DS,
        '281052': VR.DS,
        '281053': VR.DS,
        '281054': VR.LO,
        '281055': VR.LO,
        '281056': VR.CS,
        '281080': VR.CS,
        '281090': VR.CS,
        '281100': VR.SS,
        '281101': VR.SS,
        '281102': VR.SS,
        '281103': VR.SS,
        '281104': VR.US,
        '281111': VR.SS,
        '281112': VR.SS,
        '281113': VR.SS,
        '281199': VR.UI,
        '281200': VR.OW,
        '281201': VR.OW,
        '281202': VR.OW,
        '281203': VR.OW,
        '281204': VR.OW,
        '281211': VR.OW,
        '281212': VR.OW,
        '281213': VR.OW,
        '281214': VR.UI,
        '281221': VR.OW,
        '281222': VR.OW,
        '281223': VR.OW,
        '281224': VR.OW,
        '281230': VR.SQ,
        '281231': VR.FD,
        '281232': VR.FD,
        '281300': VR.CS,
        '281350': VR.CS,
        '281351': VR.ST,
        '281352': VR.SQ,
        '28135a': VR.CS,
        '281401': VR.SQ,
        '281402': VR.CS,
        '281403': VR.US,
        '281404': VR.SQ,
        '281405': VR.CS,
        '281406': VR.FD,
        '281407': VR.US,
        '281408': VR.OW,
        '28140b': VR.SQ,
        '28140c': VR.SQ,
        '28140d': VR.CS,
        '28140e': VR.CS,
        '28140f': VR.CS,
        '281410': VR.CS,
        '282000': VR.OB,
        '282002': VR.CS,
        '282110': VR.CS,
        '282112': VR.DS,
        '282114': VR.CS,
        '283000': VR.SQ,
        '283002': VR.SS,
        '283003': VR.LO,
        '283004': VR.LO,
        '283006': VR.OW,
        '283010': VR.SQ,
        '283110': VR.SQ,
        '284000': VR.LT,
        '285000': VR.SQ,
        '286010': VR.US,
        '286020': VR.US,
        '286022': VR.LO,
        '286023': VR.CS,
        '286030': VR.US,
        '286040': VR.US,
        '286100': VR.SQ,
        '286101': VR.CS,
        '286102': VR.US,
        '286110': VR.US,
        '286112': VR.US,
        '286114': VR.FL,
        '286120': VR.SS,
        '286190': VR.ST,
        '287000': VR.SQ,
        '287001': VR.US,
        '287002': VR.US,
        '287003': VR.US,
        '287004': VR.SH,
        '287005': VR.LO,
        '287006': VR.CS,
        '287007': VR.LO,
        '287008': VR.SQ,
        '287009': VR.US,
        '28700a': VR.SQ,
        '28700b': VR.US,
        '28700c': VR.SH,
        '28700d': VR.LO,
        '28700e': VR.US,
        '28700f': VR.SQ,
        '287010': VR.SQ,
        '287011': VR.SQ,
        '287012': VR.SQ,
        '287013': VR.CS,
        '287014': VR.CS,
        '287015': VR.SQ,
        '287016': VR.SQ,
        '287017': VR.US,
        '287018': VR.FL,
        '287019': VR.CS,
        '28701a': VR.FL,
        '28701b': VR.US,
        '28701c': VR.SQ,
        '28701d': VR.FL,
        '28701e': VR.FL,
        '28701f': VR.FL,
        '287020': VR.LO,
        '287021': VR.CS,
        '287022': VR.SQ,
        '287023': VR.SQ,
        '287024': VR.SQ,
        '287025': VR.CS,
        '287026': VR.CS,
        '287027': VR.SQ,
        '287028': VR.SQ,
        '287029': VR.CS,
        '28702a': VR.LO,
        '28702b': VR.CS,
        '28702c': VR.SQ,
        '28702d': VR.SQ,
        '28702e': VR.SQ,
        '287fe0': VR.UR,
        '289001': VR.UL,
        '289002': VR.UL,
        '289003': VR.CS,
        '289099': VR.US,
        '289108': VR.CS,
        '289110': VR.SQ,
        '289132': VR.SQ,
        '289145': VR.SQ,
        '289235': VR.CS,
        '289411': VR.FL,
        '289415': VR.SQ,
        '289416': VR.US,
        '289422': VR.SQ,
        '289443': VR.SQ,
        '289444': VR.CS,
        '289445': VR.FL,
        '289446': VR.CS,
        '289454': VR.CS,
        '289474': VR.CS,
        '289478': VR.FL,
        '289501': VR.SQ,
        '289502': VR.SQ,
        '289503': VR.SS,
        '289505': VR.SQ,
        '289506': VR.US,
        '289507': VR.US,
        '289520': VR.DS,
        '289537': VR.CS,
        '32000a': VR.CS,
        '32000c': VR.CS,
        '320012': VR.LO,
        '320032': VR.DA,
        '320033': VR.TM,
        '320034': VR.DA,
        '320035': VR.TM,
        '321000': VR.DA,
        '321001': VR.TM,
        '321010': VR.DA,
        '321011': VR.TM,
        '321020': VR.LO,
        '321021': VR.AE,
        '321030': VR.LO,
        '321031': VR.SQ,
        '321032': VR.PN,
        '321033': VR.LO,
        '321034': VR.SQ,
        '321040': VR.DA,
        '321041': VR.TM,
        '321050': VR.DA,
        '321051': VR.TM,
        '321055': VR.CS,
        '321060': VR.LO,
        '321064': VR.SQ,
        '321070': VR.LO,
        '324000': VR.LT,
        '380004': VR.SQ,
        '380008': VR.CS,
        '380010': VR.LO,
        '380011': VR.LO,
        '380014': VR.SQ,
        '380016': VR.LO,
        '38001a': VR.DA,
        '38001b': VR.TM,
        '38001c': VR.DA,
        '38001d': VR.TM,
        '38001e': VR.LO,
        '380020': VR.DA,
        '380021': VR.TM,
        '380030': VR.DA,
        '380032': VR.TM,
        '380040': VR.LO,
        '380044': VR.SQ,
        '380050': VR.LO,
        '380060': VR.LO,
        '380061': VR.LO,
        '380062': VR.LO,
        '380064': VR.SQ,
        '380100': VR.SQ,
        '380101': VR.SQ,
        '380102': VR.LO,
        '380300': VR.LO,
        '380400': VR.LO,
        '380500': VR.LO,
        '380502': VR.SQ,
        '384000': VR.LT,
        '3a0004': VR.CS,
        '3a0005': VR.US,
        '3a0010': VR.UL,
        '3a001a': VR.DS,
        '3a0020': VR.SH,
        '3a0200': VR.SQ,
        '3a0202': VR.IS,
        '3a0203': VR.SH,
        '3a0205': VR.CS,
        '3a0208': VR.SQ,
        '3a0209': VR.SQ,
        '3a020a': VR.SQ,
        '3a020c': VR.LO,
        '3a0210': VR.DS,
        '3a0211': VR.SQ,
        '3a0212': VR.DS,
        '3a0213': VR.DS,
        '3a0214': VR.DS,
        '3a0215': VR.DS,
        '3a0218': VR.DS,
        '3a021a': VR.US,
        '3a0220': VR.DS,
        '3a0221': VR.DS,
        '3a0222': VR.DS,
        '3a0223': VR.DS,
        '3a0230': VR.FL,
        '3a0231': VR.US,
        '3a0240': VR.SQ,
        '3a0241': VR.US,
        '3a0242': VR.SQ,
        '3a0244': VR.US,
        '3a0245': VR.FL,
        '3a0246': VR.CS,
        '3a0247': VR.FL,
        '3a0248': VR.FL,
        '3a0300': VR.SQ,
        '3a0301': VR.IS,
        '3a0302': VR.CS,
        '400001': VR.AE,
        '400002': VR.DA,
        '400003': VR.TM,
        '400004': VR.DA,
        '400005': VR.TM,
        '400006': VR.PN,
        '400007': VR.LO,
        '400008': VR.SQ,
        '400009': VR.SH,
        '40000a': VR.SQ,
        '40000b': VR.SQ,
        '400010': VR.SH,
        '400011': VR.SH,
        '400012': VR.LO,
        '400020': VR.CS,
        '400026': VR.SQ,
        '400027': VR.SQ,
        '400031': VR.UT,
        '400032': VR.UT,
        '400033': VR.CS,
        '400035': VR.CS,
        '400036': VR.SQ,
        '400039': VR.SQ,
        '40003a': VR.SQ,
        '400100': VR.SQ,
        '400220': VR.SQ,
        '400241': VR.AE,
        '400242': VR.SH,
        '400243': VR.SH,
        '400244': VR.DA,
        '400245': VR.TM,
        '400250': VR.DA,
        '400251': VR.TM,
        '400252': VR.CS,
        '400253': VR.SH,
        '400254': VR.LO,
        '400255': VR.LO,
        '400260': VR.SQ,
        '400261': VR.CS,
        '400270': VR.SQ,
        '400275': VR.SQ,
        '400280': VR.ST,
        '400281': VR.SQ,
        '400293': VR.SQ,
        '400294': VR.DS,
        '400295': VR.SQ,
        '400296': VR.SQ,
        '400300': VR.US,
        '400301': VR.US,
        '400302': VR.US,
        '400303': VR.US,
        '400306': VR.DS,
        '400307': VR.DS,
        '40030e': VR.SQ,
        '400310': VR.ST,
        '400312': VR.DS,
        '400314': VR.DS,
        '400316': VR.DS,
        '400318': VR.CS,
        '400320': VR.SQ,
        '400321': VR.SQ,
        '400324': VR.SQ,
        '400330': VR.SQ,
        '400340': VR.SQ,
        '400400': VR.LT,
        '400440': VR.SQ,
        '400441': VR.SQ,
        '400500': VR.SQ,
        '40050a': VR.LO,
        '400512': VR.LO,
        '400513': VR.SQ,
        '400515': VR.SQ,
        '400518': VR.SQ,
        '40051a': VR.LO,
        '400520': VR.SQ,
        '400550': VR.SQ,
        '400551': VR.LO,
        '400552': VR.SQ,
        '400553': VR.ST,
        '400554': VR.UI,
        '400555': VR.SQ,
        '400556': VR.ST,
        '400560': VR.SQ,
        '400562': VR.SQ,
        '40059a': VR.SQ,
        '400600': VR.LO,
        '400602': VR.UT,
        '400610': VR.SQ,
        '400612': VR.SQ,
        '400620': VR.SQ,
        '4006fa': VR.LO,
        '40071a': VR.SQ,
        '40072a': VR.DS,
        '40073a': VR.DS,
        '40074a': VR.DS,
        '4008d8': VR.SQ,
        '4008da': VR.SQ,
        '4008ea': VR.SQ,
        '4009f8': VR.SQ,
        '401001': VR.SH,
        '401002': VR.LO,
        '401003': VR.SH,
        '401004': VR.LO,
        '401005': VR.LO,
        '401006': VR.SH,
        '401007': VR.SH,
        '401008': VR.LO,
        '401009': VR.SH,
        '40100a': VR.SQ,
        '401010': VR.PN,
        '401011': VR.SQ,
        '401012': VR.SQ,
        '401060': VR.LO,
        '401101': VR.SQ,
        '401102': VR.ST,
        '401103': VR.LO,
        '401104': VR.LT,
        '401400': VR.LT,
        '402001': VR.LO,
        '402004': VR.DA,
        '402005': VR.TM,
        '402006': VR.SH,
        '402007': VR.SH,
        '402008': VR.PN,
        '402009': VR.SH,
        '402010': VR.SH,
        '402011': VR.LT,
        '402016': VR.LO,
        '402017': VR.LO,
        '402400': VR.LT,
        '403001': VR.LO,
        '404001': VR.CS,
        '404002': VR.CS,
        '404003': VR.CS,
        '404004': VR.SQ,
        '404005': VR.DT,
        '404006': VR.CS,
        '404007': VR.SQ,
        '404009': VR.SQ,
        '404010': VR.DT,
        '404011': VR.DT,
        '404015': VR.SQ,
        '404016': VR.SQ,
        '404018': VR.SQ,
        '404019': VR.SQ,
        '404020': VR.CS,
        '404021': VR.SQ,
        '404022': VR.SQ,
        '404023': VR.UI,
        '404025': VR.SQ,
        '404026': VR.SQ,
        '404027': VR.SQ,
        '404028': VR.SQ,
        '404029': VR.SQ,
        '404030': VR.SQ,
        '404031': VR.SQ,
        '404032': VR.SQ,
        '404033': VR.SQ,
        '404034': VR.SQ,
        '404035': VR.SQ,
        '404036': VR.LO,
        '404037': VR.PN,
        '404040': VR.CS,
        '404041': VR.CS,
        '404050': VR.DT,
        '404051': VR.DT,
        '404052': VR.DT,
        '404070': VR.SQ,
        '404071': VR.SQ,
        '404072': VR.SQ,
        '404073': VR.UR,
        '404074': VR.SQ,
        '408302': VR.DS,
        '408303': VR.CS,
        '409092': VR.SQ,
        '409094': VR.SQ,
        '409096': VR.SQ,
        '409098': VR.SQ,
        '409210': VR.SH,
        '409211': VR.SS,
        '409212': VR.FD,
        '409213': VR.FD,
        '409214': VR.FD,
        '409216': VR.SS,
        '409220': VR.SQ,
        '409224': VR.FD,
        '409225': VR.FD,
        '40a007': VR.CS,
        '40a010': VR.CS,
        '40a020': VR.SQ,
        '40a021': VR.UI,
        '40a022': VR.UI,
        '40a023': VR.DA,
        '40a024': VR.TM,
        '40a026': VR.SQ,
        '40a027': VR.LO,
        '40a028': VR.SQ,
        '40a030': VR.DT,
        '40a032': VR.DT,
        '40a040': VR.CS,
        '40a043': VR.SQ,
        '40a047': VR.LO,
        '40a050': VR.CS,
        '40a057': VR.CS,
        '40a060': VR.LO,
        '40a066': VR.SQ,
        '40a067': VR.PN,
        '40a068': VR.SQ,
        '40a070': VR.SQ,
        '40a073': VR.SQ,
        '40a074': VR.OB,
        '40a075': VR.PN,
        '40a076': VR.SQ,
        '40a078': VR.SQ,
        '40a07a': VR.SQ,
        '40a07c': VR.SQ,
        '40a080': VR.CS,
        '40a082': VR.DT,
        '40a084': VR.CS,
        '40a085': VR.SQ,
        '40a088': VR.SQ,
        '40a089': VR.OB,
        '40a090': VR.SQ,
        '40a0b0': VR.US,
        '40a110': VR.DA,
        '40a112': VR.TM,
        '40a120': VR.DT,
        '40a121': VR.DA,
        '40a122': VR.TM,
        '40a123': VR.PN,
        '40a124': VR.UI,
        '40a125': VR.CS,
        '40a130': VR.CS,
        '40a132': VR.UL,
        '40a136': VR.US,
        '40a138': VR.DS,
        '40a13a': VR.DT,
        '40a160': VR.UT,
        '40a161': VR.FD,
        '40a162': VR.SL,
        '40a163': VR.UL,
        '40a167': VR.SQ,
        '40a168': VR.SQ,
        '40a16a': VR.ST,
        '40a170': VR.SQ,
        '40a171': VR.UI,
        '40a172': VR.UI,
        '40a173': VR.CS,
        '40a174': VR.CS,
        '40a180': VR.US,
        '40a192': VR.DA,
        '40a193': VR.TM,
        '40a194': VR.CS,
        '40a195': VR.SQ,
        '40a224': VR.ST,
        '40a290': VR.CS,
        '40a296': VR.SQ,
        '40a297': VR.ST,
        '40a29a': VR.SL,
        '40a300': VR.SQ,
        '40a301': VR.SQ,
        '40a307': VR.PN,
        '40a30a': VR.DS,
        '40a313': VR.SQ,
        '40a33a': VR.ST,
        '40a340': VR.SQ,
        '40a352': VR.PN,
        '40a353': VR.ST,
        '40a354': VR.LO,
        '40a358': VR.SQ,
        '40a360': VR.SQ,
        '40a370': VR.SQ,
        '40a372': VR.SQ,
        '40a375': VR.SQ,
        '40a380': VR.SQ,
        '40a385': VR.SQ,
        '40a390': VR.SQ,
        '40a402': VR.UI,
        '40a403': VR.CS,
        '40a404': VR.SQ,
        '40a491': VR.CS,
        '40a492': VR.LO,
        '40a493': VR.CS,
        '40a494': VR.CS,
        '40a496': VR.CS,
        '40a504': VR.SQ,
        '40a525': VR.SQ,
        '40a600': VR.CS,
        '40a601': VR.CS,
        '40a603': VR.CS,
        '40a730': VR.SQ,
        '40a731': VR.SQ,
        '40a732': VR.SQ,
        '40a744': VR.SQ,
        '40a992': VR.ST,
        '40b020': VR.SQ,
        '40db00': VR.CS,
        '40db06': VR.DT,
        '40db07': VR.DT,
        '40db0b': VR.CS,
        '40db0c': VR.UI,
        '40db0d': VR.UI,
        '40db73': VR.UL,
        '40e001': VR.ST,
        '40e004': VR.DT,
        '40e006': VR.SQ,
        '40e008': VR.SQ,
        '40e010': VR.UR,
        '40e011': VR.UI,
        '40e020': VR.CS,
        '40e021': VR.SQ,
        '40e022': VR.SQ,
        '40e023': VR.SQ,
        '40e024': VR.SQ,
        '40e025': VR.SQ,
        '40e030': VR.UI,
        '40e031': VR.UI,
        '420010': VR.ST,
        '420011': VR.OB,
        '420012': VR.LO,
        '420013': VR.SQ,
        '420014': VR.LO,
        '440001': VR.ST,
        '440002': VR.CS,
        '440003': VR.LT,
        '440004': VR.DT,
        '440007': VR.SQ,
        '440008': VR.LO,
        '440009': VR.LT,
        '44000a': VR.LO,
        '44000b': VR.DT,
        '440010': VR.DT,
        '440011': VR.LO,
        '440012': VR.LO,
        '440013': VR.SQ,
        '440019': VR.SQ,
        '440100': VR.SQ,
        '440101': VR.SQ,
        '440102': VR.UI,
        '440103': VR.SQ,
        '440104': VR.DT,
        '440105': VR.DT,
        '440106': VR.UT,
        '440107': VR.SQ,
        '440108': VR.UI,
        '440109': VR.SQ,
        '44010a': VR.SQ,
        '460012': VR.LO,
        '460014': VR.SQ,
        '460015': VR.SQ,
        '460016': VR.SQ,
        '460018': VR.SQ,
        '460028': VR.SQ,
        '460030': VR.FD,
        '460032': VR.CS,
        '460034': VR.FD,
        '460036': VR.CS,
        '460038': VR.CS,
        '460040': VR.FD,
        '460042': VR.FD,
        '460044': VR.FD,
        '460046': VR.FD,
        '460050': VR.SQ,
        '460052': VR.SQ,
        '460060': VR.FD,
        '460062': VR.FD,
        '460063': VR.FD,
        '460064': VR.FD,
        '460070': VR.SQ,
        '460071': VR.SQ,
        '460074': VR.SQ,
        '460075': VR.FD,
        '460076': VR.FD,
        '460077': VR.FD,
        '460080': VR.SQ,
        '460092': VR.CS,
        '460094': VR.CS,
        '460095': VR.CS,
        '460097': VR.SQ,
        '460098': VR.SQ,
        '460100': VR.SQ,
        '460101': VR.SQ,
        '460102': VR.SQ,
        '460104': VR.FD,
        '460106': VR.FD,
        '460121': VR.SQ,
        '460122': VR.SQ,
        '460123': VR.SQ,
        '460124': VR.SQ,
        '460125': VR.CS,
        '460135': VR.SS,
        '460137': VR.FD,
        '460139': VR.LO,
        '460145': VR.SQ,
        '460146': VR.FD,
        '460147': VR.FD,
        '460201': VR.CS,
        '460202': VR.FL,
        '460203': VR.FL,
        '460204': VR.FL,
        '460205': VR.FL,
        '460207': VR.SQ,
        '460208': VR.IS,
        '460210': VR.SQ,
        '460211': VR.SQ,
        '460212': VR.FL,
        '460213': VR.FL,
        '460215': VR.SQ,
        '460218': VR.SQ,
        '460220': VR.FL,
        '460224': VR.FL,
        '460227': VR.FL,
        '460230': VR.FL,
        '460232': VR.FL,
        '460234': VR.FL,
        '460236': VR.FL,
        '460238': VR.FL,
        '460242': VR.CS,
        '460244': VR.SQ,
        '460247': VR.FL,
        '460248': VR.CS,
        '460249': VR.FL,
        '460250': VR.FL,
        '460251': VR.FL,
        '460252': VR.FL,
        '460253': VR.FL,
        '480001': VR.FL,
        '480002': VR.FL,
        '480003': VR.FL,
        '480006': VR.UL,
        '480007': VR.UL,
        '480008': VR.SQ,
        '480010': VR.CS,
        '480011': VR.CS,
        '480012': VR.CS,
        '480013': VR.US,
        '480014': VR.FL,
        '480015': VR.US,
        '480100': VR.SQ,
        '480102': VR.DS,
        '480105': VR.SQ,
        '480106': VR.SH,
        '480107': VR.ST,
        '480108': VR.SQ,
        '480110': VR.SQ,
        '480111': VR.DS,
        '480112': VR.DS,
        '480113': VR.DS,
        '480120': VR.SQ,
        '480200': VR.SQ,
        '480201': VR.US,
        '480202': VR.US,
        '480207': VR.SQ,
        '48021a': VR.SQ,
        '48021e': VR.SL,
        '48021f': VR.SL,
        '480301': VR.CS,
        '500004': VR.CS,
        '500010': VR.SQ,
        '500012': VR.SQ,
        '500013': VR.FD,
        '500014': VR.DS,
        '500015': VR.FD,
        '500016': VR.DS,
        '500017': VR.CS,
        '500018': VR.DS,
        '500019': VR.DS,
        '50001a': VR.CS,
        '50001b': VR.LO,
        '50001c': VR.FD,
        '50001d': VR.FD,
        '50001e': VR.LO,
        '500020': VR.LO,
        '520001': VR.FL,
        '520002': VR.FD,
        '520003': VR.FD,
        '520004': VR.FD,
        '520006': VR.CS,
        '520007': VR.FD,
        '520008': VR.FD,
        '520009': VR.FD,
        '520011': VR.FD,
        '520012': VR.US,
        '520013': VR.FD,
        '520014': VR.FD,
        '520016': VR.SQ,
        '520025': VR.SQ,
        '520026': VR.CS,
        '520027': VR.SQ,
        '520028': VR.FD,
        '520029': VR.SQ,
        '520030': VR.SS,
        '520031': VR.CS,
        '520033': VR.FD,
        '520034': VR.FD,
        '520036': VR.US,
        '520038': VR.US,
        '520039': VR.CS,
        '52003a': VR.CS,
        '540010': VR.US,
        '540011': VR.US,
        '540012': VR.SQ,
        '540013': VR.SQ,
        '540014': VR.DS,
        '540015': VR.DS,
        '540016': VR.SQ,
        '540017': VR.IS,
        '540018': VR.SH,
        '540020': VR.US,
        '540021': VR.US,
        '540022': VR.SQ,
        '540030': VR.US,
        '540031': VR.US,
        '540032': VR.SQ,
        '540033': VR.US,
        '540036': VR.IS,
        '540038': VR.IS,
        '540039': VR.CS,
        '540050': VR.US,
        '540051': VR.US,
        '540052': VR.SQ,
        '540053': VR.US,
        '540060': VR.US,
        '540061': VR.US,
        '540062': VR.SQ,
        '540063': VR.SQ,
        '540070': VR.US,
        '540071': VR.US,
        '540072': VR.SQ,
        '540073': VR.DS,
        '540080': VR.US,
        '540081': VR.US,
        '540090': VR.US,
        '540100': VR.US,
        '540101': VR.US,
        '540200': VR.DS,
        '540202': VR.CS,
        '540210': VR.IS,
        '540211': VR.US,
        '540220': VR.SQ,
        '540222': VR.SQ,
        '540300': VR.SQ,
        '540302': VR.SQ,
        '540304': VR.SQ,
        '540306': VR.SQ,
        '540308': VR.US,
        '540400': VR.SH,
        '540410': VR.SQ,
        '540412': VR.SQ,
        '540414': VR.SQ,
        '540500': VR.CS,
        '540501': VR.CS,
        '541000': VR.CS,
        '541001': VR.CS,
        '541002': VR.CS,
        '541004': VR.CS,
        '541006': VR.CS,
        '541100': VR.CS,
        '541101': VR.LO,
        '541102': VR.CS,
        '541103': VR.LO,
        '541104': VR.LO,
        '541105': VR.LO,
        '541200': VR.DS,
        '541201': VR.IS,
        '541202': VR.IS,
        '541203': VR.DS,
        '541210': VR.DS,
        '541220': VR.CS,
        '541300': VR.DS,
        '541310': VR.IS,
        '541311': VR.IS,
        '541320': VR.DS,
        '541321': VR.DS,
        '541322': VR.DS,
        '541323': VR.DS,
        '541324': VR.DS,
        '541330': VR.US,
        '541400': VR.CS,
        '541401': VR.CS,
        '603000': VR.SQ,
        '603002': VR.US,
        '603004': VR.SS,
        '603006': VR.SS,
        '603008': VR.US,
        '603010': VR.LO,
        '603020': VR.UL,
        '620001': VR.CS,
        '620002': VR.SQ,
        '620003': VR.SQ,
        '620004': VR.US,
        '620005': VR.LO,
        '620006': VR.ST,
        '620007': VR.SQ,
        '620008': VR.CS,
        '620009': VR.LO,
        '62000a': VR.SQ,
        '62000b': VR.US,
        '62000c': VR.US,
        '62000d': VR.US,
        '62000e': VR.US,
        '62000f': VR.SQ,
        '620010': VR.CS,
        '620011': VR.SQ,
        '620012': VR.SQ,
        '620020': VR.UT,
        '620021': VR.UI,
        '640002': VR.SQ,
        '640003': VR.UI,
        '640005': VR.SQ,
        '640007': VR.UL,
        '640008': VR.FD,
        '640009': VR.OF,
        '64000f': VR.SQ,
        '640010': VR.SQ,
        '660001': VR.UL,
        '660002': VR.SQ,
        '660003': VR.UL,
        '660004': VR.LT,
        '660009': VR.CS,
        '66000a': VR.FL,
        '66000b': VR.LO,
        '66000c': VR.FL,
        '66000d': VR.CS,
        '66000e': VR.CS,
        '660010': VR.CS,
        '660011': VR.SQ,
        '660012': VR.SQ,
        '660013': VR.SQ,
        '660015': VR.UL,
        '660016': VR.OF,
        '660017': VR.FL,
        '660018': VR.FL,
        '660019': VR.FL,
        '66001a': VR.FL,
        '66001b': VR.FL,
        '66001c': VR.FL,
        '66001e': VR.UL,
        '66001f': VR.US,
        '660020': VR.FL,
        '660021': VR.OF,
        '660023': VR.OW,
        '660024': VR.OW,
        '660025': VR.OW,
        '660026': VR.SQ,
        '660027': VR.SQ,
        '660028': VR.SQ,
        '660029': VR.OW,
        '66002a': VR.UL,
        '66002b': VR.SQ,
        '66002c': VR.UL,
        '66002d': VR.SQ,
        '66002e': VR.SQ,
        '66002f': VR.SQ,
        '660030': VR.SQ,
        '660031': VR.LO,
        '660032': VR.LT,
        '660034': VR.SQ,
        '660035': VR.SQ,
        '660036': VR.LO,
        '660037': VR.FL,
        '660038': VR.FL,
        '660040': VR.OL,
        '660041': VR.OL,
        '660042': VR.OL,
        '660043': VR.OL,
        '660101': VR.SQ,
        '660102': VR.SQ,
        '660103': VR.OW,
        '660104': VR.SQ,
        '660105': VR.UL,
        '660106': VR.LO,
        '660107': VR.UT,
        '660108': VR.SQ,
        '660121': VR.SQ,
        '660124': VR.SQ,
        '660125': VR.OF,
        '660129': VR.OL,
        '660130': VR.SQ,
        '660132': VR.SQ,
        '660133': VR.SQ,
        '660134': VR.SQ,
        '686210': VR.LO,
        '686221': VR.LO,
        '686222': VR.SQ,
        '686223': VR.CS,
        '686224': VR.SQ,
        '686225': VR.SQ,
        '686226': VR.DT,
        '686230': VR.SQ,
        '686260': VR.SQ,
        '686265': VR.SQ,
        '686270': VR.DT,
        '686280': VR.ST,
        '6862a0': VR.SQ,
        '6862a5': VR.FD,
        '6862c0': VR.SQ,
        '6862d0': VR.US,
        '6862d5': VR.LO,
        '6862e0': VR.SQ,
        '6862f0': VR.SQ,
        '6862f2': VR.FD,
        '686300': VR.OB,
        '686310': VR.US,
        '686320': VR.SQ,
        '686330': VR.US,
        '686340': VR.LO,
        '686345': VR.ST,
        '686346': VR.FD,
        '686347': VR.FD,
        '686350': VR.US,
        '686360': VR.SQ,
        '686380': VR.LO,
        '686390': VR.FD,
        '6863a0': VR.SQ,
        '6863a4': VR.SQ,
        '6863a8': VR.SQ,
        '6863ac': VR.SQ,
        '6863b0': VR.SQ,
        '6863c0': VR.US,
        '6863d0': VR.LO,
        '6863e0': VR.SQ,
        '6863f0': VR.US,
        '686400': VR.SQ,
        '686410': VR.US,
        '686420': VR.CS,
        '686430': VR.SQ,
        '686440': VR.US,
        '686450': VR.FD,
        '686460': VR.FD,
        '686470': VR.SQ,
        '686490': VR.FD,
        '6864a0': VR.FD,
        '6864c0': VR.FD,
        '6864d0': VR.FD,
        '6864f0': VR.FD,
        '686500': VR.SQ,
        '686510': VR.SQ,
        '686520': VR.SQ,
        '686530': VR.US,
        '686540': VR.LO,
        '686545': VR.SQ,
        '686550': VR.SQ,
        '686560': VR.FD,
        '686590': VR.FD,
        '6865a0': VR.SQ,
        '6865b0': VR.FD,
        '6865d0': VR.FD,
        '6865e0': VR.SQ,
        '6865f0': VR.FD,
        '686610': VR.FD,
        '686620': VR.FD,
        '700001': VR.SQ,
        '700002': VR.CS,
        '700003': VR.CS,
        '700004': VR.CS,
        '700005': VR.CS,
        '700006': VR.ST,
        '700008': VR.SQ,
        '700009': VR.SQ,
        '700010': VR.FL,
        '700011': VR.FL,
        '700012': VR.CS,
        '700014': VR.FL,
        '700015': VR.CS,
        '700020': VR.US,
        '700021': VR.US,
        '700022': VR.FL,
        '700023': VR.CS,
        '700024': VR.CS,
        '700040': VR.IS,
        '700041': VR.CS,
        '700042': VR.US,
        '700050': VR.US,
        '700051': VR.US,
        '700052': VR.SL,
        '700053': VR.SL,
        '70005a': VR.SQ,
        '700060': VR.SQ,
        '700062': VR.IS,
        '700066': VR.US,
        '700067': VR.US,
        '700068': VR.LO,
        '700080': VR.CS,
        '700081': VR.LO,
        '700082': VR.DA,
        '700083': VR.TM,
        '700084': VR.PN,
        '700086': VR.SQ,
        '700087': VR.SQ,
        '700100': VR.CS,
        '700101': VR.DS,
        '700102': VR.IS,
        '700103': VR.FL,
        '700207': VR.LO,
        '700208': VR.ST,
        '700209': VR.SQ,
        '700226': VR.UL,
        '700227': VR.LO,
        '700228': VR.CS,
        '700229': VR.LO,
        '700230': VR.FD,
        '700231': VR.SQ,
        '700232': VR.SQ,
        '700233': VR.SQ,
        '700234': VR.SQ,
        '700241': VR.US,
        '700242': VR.CS,
        '700243': VR.CS,
        '700244': VR.CS,
        '700245': VR.FL,
        '700246': VR.FL,
        '700247': VR.US,
        '700248': VR.CS,
        '700249': VR.CS,
        '700250': VR.CS,
        '700251': VR.US,
        '700252': VR.US,
        '700253': VR.FL,
        '700254': VR.CS,
        '700255': VR.UL,
        '700256': VR.OB,
        '700257': VR.CS,
        '700258': VR.FL,
        '700261': VR.FL,
        '700262': VR.FL,
        '700273': VR.FL,
        '700274': VR.CS,
        '700278': VR.CS,
        '700279': VR.CS,
        '700282': VR.CS,
        '700284': VR.FL,
        '700285': VR.FL,
        '700287': VR.SQ,
        '700288': VR.FL,
        '700289': VR.SH,
        '700294': VR.CS,
        '700295': VR.UL,
        '700306': VR.CS,
        '700308': VR.SQ,
        '700309': VR.SQ,
        '70030a': VR.SQ,
        '70030b': VR.FD,
        '70030c': VR.CS,
        '70030d': VR.SQ,
        '70030f': VR.ST,
        '700310': VR.SH,
        '700311': VR.SQ,
        '700312': VR.FD,
        '700314': VR.SQ,
        '700318': VR.SQ,
        '70031a': VR.UI,
        '70031b': VR.UI,
        '70031c': VR.SQ,
        '70031e': VR.SQ,
        '70031f': VR.SQ,
        '700401': VR.US,
        '700402': VR.SQ,
        '700403': VR.FL,
        '700404': VR.SQ,
        '700405': VR.CS,
        '701101': VR.UI,
        '701102': VR.UI,
        '701103': VR.US,
        '701104': VR.SQ,
        '701201': VR.SQ,
        '701202': VR.CS,
        '701203': VR.US,
        '701204': VR.CS,
        '701205': VR.US,
        '701206': VR.CS,
        '701207': VR.US,
        '701208': VR.CS,
        '701209': VR.UI,
        '70120a': VR.SQ,
        '70120b': VR.CS,
        '70120c': VR.US,
        '70120d': VR.CS,
        '701301': VR.SQ,
        '701302': VR.CS,
        '701303': VR.FD,
        '701304': VR.SQ,
        '701305': VR.FD,
        '701306': VR.FD,
        '701309': VR.US,
        '701501': VR.CS,
        '701502': VR.CS,
        '701503': VR.FD,
        '701505': VR.FD,
        '701507': VR.FD,
        '701508': VR.FD,
        '70150c': VR.UL,
        '70150d': VR.OD,
        '701511': VR.FD,
        '701512': VR.FD,
        '701602': VR.CS,
        '701603': VR.FD,
        '701604': VR.FD,
        '701605': VR.FD,
        '701606': VR.FD,
        '701607': VR.FD,
        '701701': VR.CS,
        '701702': VR.FD,
        '701703': VR.FD,
        '701704': VR.FD,
        '701705': VR.FD,
        '701706': VR.FD,
        '701801': VR.SQ,
        '701802': VR.CS,
        '701803': VR.SQ,
        '701804': VR.US,
        '701805': VR.SQ,
        '701806': VR.SQ,
        '701807': VR.US,
        '701808': VR.OB,
        '701901': VR.SQ,
        '701903': VR.SQ,
        '701904': VR.UI,
        '701905': VR.SQ,
        '701907': VR.CS,
        '701a01': VR.CS,
        '701a03': VR.FD,
        '701a04': VR.SQ,
        '701a05': VR.FD,
        '701a06': VR.FD,
        '701a07': VR.OD,
        '701a08': VR.SQ,
        '701a09': VR.LO,
        '701b01': VR.SQ,
        '701b02': VR.US,
        '701b03': VR.SQ,
        '701b04': VR.SQ,
        '701b06': VR.CS,
        '701b07': VR.CS,
        '701b08': VR.CS,
        '701b11': VR.SQ,
        '701b12': VR.SQ,
        '701b13': VR.CS,
        '701b14': VR.FD,
        '720002': VR.SH,
        '720004': VR.LO,
        '720006': VR.CS,
        '720008': VR.LO,
        '72000a': VR.DT,
        '72000c': VR.SQ,
        '72000e': VR.SQ,
        '720010': VR.LO,
        '720012': VR.SQ,
        '720014': VR.US,
        '720020': VR.SQ,
        '720022': VR.SQ,
        '720024': VR.CS,
        '720026': VR.AT,
        '720028': VR.US,
        '720030': VR.SQ,
        '720032': VR.US,
        '720034': VR.CS,
        '720038': VR.US,
        '72003a': VR.CS,
        '72003c': VR.SS,
        '72003e': VR.SQ,
        '720040': VR.LO,
        '720050': VR.CS,
        '720052': VR.AT,
        '720054': VR.LO,
        '720056': VR.LO,
        '72005e': VR.AE,
        '72005f': VR.AS,
        '720060': VR.AT,
        '720061': VR.DA,
        '720062': VR.CS,
        '720063': VR.DT,
        '720064': VR.IS,
        '720065': VR.OB,
        '720066': VR.LO,
        '720067': VR.OF,
        '720068': VR.LT,
        '720069': VR.OW,
        '72006a': VR.PN,
        '72006b': VR.TM,
        '72006c': VR.SH,
        '72006d': VR.UN,
        '72006e': VR.ST,
        '72006f': VR.UC,
        '720070': VR.UT,
        '720071': VR.UR,
        '720072': VR.DS,
        '720073': VR.OD,
        '720074': VR.FD,
        '720075': VR.OL,
        '720076': VR.FL,
        '720078': VR.UL,
        '72007a': VR.US,
        '72007c': VR.SL,
        '72007e': VR.SS,
        '72007f': VR.UI,
        '720080': VR.SQ,
        '720100': VR.US,
        '720102': VR.SQ,
        '720104': VR.US,
        '720106': VR.US,
        '720108': VR.FD,
        '72010a': VR.US,
        '72010c': VR.US,
        '72010e': VR.US,
        '720200': VR.SQ,
        '720202': VR.US,
        '720203': VR.LO,
        '720204': VR.US,
        '720206': VR.LO,
        '720208': VR.CS,
        '720210': VR.SQ,
        '720212': VR.US,
        '720214': VR.SQ,
        '720216': VR.US,
        '720218': VR.US,
        '720300': VR.SQ,
        '720302': VR.US,
        '720304': VR.CS,
        '720306': VR.US,
        '720308': VR.US,
        '720310': VR.CS,
        '720312': VR.CS,
        '720314': VR.US,
        '720316': VR.CS,
        '720318': VR.US,
        '720320': VR.US,
        '720330': VR.FD,
        '720400': VR.SQ,
        '720402': VR.CS,
        '720404': VR.CS,
        '720406': VR.CS,
        '720420': VR.US,
        '720421': VR.US,
        '720422': VR.SQ,
        '720424': VR.SQ,
        '720427': VR.SQ,
        '720430': VR.SQ,
        '720432': VR.US,
        '720434': VR.CS,
        '720500': VR.CS,
        '720510': VR.CS,
        '720512': VR.FD,
        '720514': VR.FD,
        '720516': VR.CS,
        '720520': VR.CS,
        '720600': VR.SQ,
        '720602': VR.CS,
        '720604': VR.CS,
        '720700': VR.CS,
        '720702': VR.CS,
        '720704': VR.CS,
        '720705': VR.SQ,
        '720706': VR.CS,
        '720710': VR.CS,
        '720712': VR.CS,
        '720714': VR.CS,
        '720716': VR.CS,
        '720717': VR.CS,
        '720718': VR.CS,
        '740120': VR.FD,
        '740121': VR.FD,
        '741000': VR.CS,
        '741002': VR.SQ,
        '741004': VR.DS,
        '741006': VR.ST,
        '741007': VR.SQ,
        '741008': VR.SQ,
        '74100a': VR.UR,
        '74100c': VR.LO,
        '74100e': VR.SQ,
        '741020': VR.SQ,
        '741022': VR.CS,
        '741024': VR.IS,
        '741025': VR.CS,
        '741026': VR.FD,
        '741027': VR.FD,
        '741028': VR.FD,
        '74102a': VR.FD,
        '74102b': VR.FD,
        '74102c': VR.FD,
        '74102d': VR.FD,
        '741030': VR.SQ,
        '741032': VR.CS,
        '741034': VR.CS,
        '741036': VR.CS,
        '741038': VR.DS,
        '74103a': VR.DS,
        '741040': VR.SQ,
        '741042': VR.SQ,
        '741044': VR.SQ,
        '741046': VR.SQ,
        '741048': VR.SQ,
        '74104a': VR.SQ,
        '74104c': VR.SQ,
        '74104e': VR.SQ,
        '741050': VR.SQ,
        '741052': VR.AT,
        '741054': VR.UL,
        '741056': VR.LO,
        '741057': VR.IS,
        '741200': VR.CS,
        '741202': VR.LO,
        '741204': VR.LO,
        '741210': VR.SQ,
        '741212': VR.SQ,
        '741216': VR.SQ,
        '741220': VR.SQ,
        '741222': VR.LO,
        '741224': VR.SQ,
        '741230': VR.LO,
        '741234': VR.AE,
        '741236': VR.AE,
        '741238': VR.LT,
        '741242': VR.CS,
        '741244': VR.CS,
        '741246': VR.CS,
        '741324': VR.UL,
        '741338': VR.FD,
        '74133a': VR.FD,
        '741401': VR.SQ,
        '741402': VR.DS,
        '741403': VR.DS,
        '741404': VR.IS,
        '741405': VR.SQ,
        '741406': VR.IS,
        '741407': VR.DS,
        '741408': VR.DS,
        '741409': VR.SQ,
        '74140a': VR.CS,
        '74140b': VR.LO,
        '74140c': VR.IS,
        '74140d': VR.SQ,
        '74140e': VR.SQ,
        '760001': VR.LO,
        '760003': VR.LO,
        '760006': VR.LO,
        '760008': VR.SQ,
        '76000a': VR.CS,
        '76000c': VR.SQ,
        '76000e': VR.SQ,
        '760010': VR.SQ,
        '760020': VR.SQ,
        '760030': VR.LO,
        '760032': VR.SQ,
        '760034': VR.SQ,
        '760036': VR.CS,
        '760038': VR.CS,
        '760040': VR.SQ,
        '760055': VR.US,
        '760060': VR.SQ,
        '760070': VR.US,
        '760080': VR.US,
        '760090': VR.US,
        '7600a0': VR.US,
        '7600b0': VR.US,
        '7600c0': VR.US,
        '780001': VR.LO,
        '780010': VR.ST,
        '780020': VR.LO,
        '780024': VR.LO,
        '780026': VR.SQ,
        '780028': VR.SQ,
        '78002a': VR.SQ,
        '78002e': VR.US,
        '780050': VR.FD,
        '780060': VR.FD,
        '780070': VR.SQ,
        '780090': VR.FD,
        '7800a0': VR.FD,
        '7800b0': VR.SQ,
        '7800b2': VR.LO,
        '7800b4': VR.SQ,
        '7800b6': VR.US,
        '7800b8': VR.US,
        '800001': VR.SQ,
        '800002': VR.SQ,
        '800003': VR.SQ,
        '800004': VR.FD,
        '800005': VR.FD,
        '800006': VR.US,
        '800007': VR.US,
        '800008': VR.SQ,
        '800009': VR.SH,
        '800010': VR.OF,
        '800011': VR.OF,
        '800012': VR.SQ,
        '800013': VR.SQ,
        '820001': VR.CS,
        '820003': VR.UT,
        '820004': VR.SQ,
        '820005': VR.SQ,
        '820006': VR.UL,
        '820007': VR.SQ,
        '820008': VR.CS,
        '82000a': VR.UT,
        '82000c': VR.SQ,
        '820010': VR.SQ,
        '820016': VR.LO,
        '820017': VR.SQ,
        '820018': VR.LO,
        '820019': VR.LO,
        '820021': VR.SQ,
        '820022': VR.SQ,
        '820023': VR.LO,
        '820032': VR.CS,
        '820033': VR.UT,
        '820034': VR.SQ,
        '820035': VR.SQ,
        '820036': VR.CS,
        '820037': VR.UT,
        '820038': VR.CS,
        '880130': VR.SH,
        '880140': VR.UI,
        '880200': VR.SQ,
        '880904': VR.LO,
        '880906': VR.ST,
        '880910': VR.LO,
        '880912': VR.LO,
        '1000410': VR.CS,
        '1000420': VR.DT,
        '1000424': VR.LT,
        '1000426': VR.LO,
        '4000005': VR.US,
        '4000010': VR.UI,
        '4000015': VR.CS,
        '4000020': VR.AT,
        '4000100': VR.UI,
        '4000105': VR.DT,
        '4000110': VR.CS,
        '4000115': VR.OB,
        '4000120': VR.OB,
        '4000305': VR.CS,
        '4000310': VR.OB,
        '4000401': VR.SQ,
        '4000402': VR.SQ,
        '4000403': VR.SQ,
        '4000404': VR.OB,
        '4000500': VR.SQ,
        '4000510': VR.UI,
        '4000520': VR.OB,
        '4000550': VR.SQ,
        '4000561': VR.SQ,
        '4000562': VR.DT,
        '4000563': VR.LO,
        '4000564': VR.LO,
        '4000565': VR.CS,
        '10000000': VR.US,
        '10000001': VR.US,
        '10000002': VR.US,
        '10000003': VR.US,
        '10000004': VR.US,
        '10000005': VR.US,
        '10100000': VR.US,
        '20000010': VR.IS,
        '2000001e': VR.SQ,
        '20000020': VR.CS,
        '20000030': VR.CS,
        '20000040': VR.CS,
        '20000050': VR.LO,
        '20000060': VR.IS,
        '20000061': VR.IS,
        '20000062': VR.CS,
        '20000063': VR.CS,
        '20000065': VR.CS,
        '20000067': VR.CS,
        '20000069': VR.CS,
        '2000006a': VR.CS,
        '200000a0': VR.US,
        '200000a1': VR.US,
        '200000a2': VR.SQ,
        '200000a4': VR.SQ,
        '200000a8': VR.SQ,
        '20000500': VR.SQ,
        '20000510': VR.SQ,
        '20100010': VR.ST,
        '20100030': VR.CS,
        '20100040': VR.CS,
        '20100050': VR.CS,
        '20100052': VR.CS,
        '20100054': VR.CS,
        '20100060': VR.CS,
        '20100080': VR.CS,
        '201000a6': VR.CS,
        '201000a7': VR.CS,
        '201000a8': VR.CS,
        '201000a9': VR.CS,
        '20100100': VR.CS,
        '20100110': VR.CS,
        '20100120': VR.US,
        '20100130': VR.US,
        '20100140': VR.CS,
        '20100150': VR.ST,
        '20100152': VR.LT,
        '20100154': VR.IS,
        '2010015e': VR.US,
        '20100160': VR.US,
        '20100376': VR.DS,
        '20100500': VR.SQ,
        '20100510': VR.SQ,
        '20100520': VR.SQ,
        '20200010': VR.US,
        '20200020': VR.CS,
        '20200030': VR.DS,
        '20200040': VR.CS,
        '20200050': VR.CS,
        '202000a0': VR.CS,
        '202000a2': VR.CS,
        '20200110': VR.SQ,
        '20200111': VR.SQ,
        '20200130': VR.SQ,
        '20200140': VR.SQ,
        '20300010': VR.US,
        '20300020': VR.LO,
        '20400010': VR.SQ,
        '20400011': VR.US,
        '20400020': VR.SQ,
        '20400060': VR.CS,
        '20400070': VR.CS,
        '20400072': VR.CS,
        '20400074': VR.US,
        '20400080': VR.CS,
        '20400082': VR.CS,
        '20400090': VR.CS,
        '20400100': VR.CS,
        '20400500': VR.SQ,
        '20500010': VR.SQ,
        '20500020': VR.CS,
        '20500500': VR.SQ,
        '21000010': VR.SH,
        '21000020': VR.CS,
        '21000030': VR.CS,
        '21000040': VR.DA,
        '21000050': VR.TM,
        '21000070': VR.AE,
        '21000140': VR.AE,
        '21000160': VR.SH,
        '21000170': VR.IS,
        '21000500': VR.SQ,
        '21100010': VR.CS,
        '21100020': VR.CS,
        '21100030': VR.LO,
        '21100099': VR.SH,
        '21200010': VR.CS,
        '21200050': VR.SQ,
        '21200070': VR.SQ,
        '21300010': VR.SQ,
        '21300015': VR.SQ,
        '21300030': VR.SQ,
        '21300040': VR.SQ,
        '21300050': VR.SQ,
        '21300060': VR.SQ,
        '21300080': VR.SQ,
        '213000a0': VR.SQ,
        '213000c0': VR.SQ,
        '22000001': VR.CS,
        '22000002': VR.UT,
        '22000003': VR.CS,
        '22000004': VR.LT,
        '22000005': VR.LT,
        '22000006': VR.CS,
        '22000007': VR.CS,
        '22000008': VR.CS,
        '22000009': VR.CS,
        '2200000a': VR.CS,
        '2200000b': VR.US,
        '2200000c': VR.LO,
        '2200000d': VR.SQ,
        '2200000e': VR.AT,
        '2200000f': VR.CS,
        '22000020': VR.CS,
        '30020002': VR.SH,
        '30020003': VR.LO,
        '30020004': VR.ST,
        '3002000a': VR.CS,
        '3002000c': VR.CS,
        '3002000d': VR.DS,
        '3002000e': VR.DS,
        '30020010': VR.DS,
        '30020011': VR.DS,
        '30020012': VR.DS,
        '30020020': VR.SH,
        '30020022': VR.DS,
        '30020024': VR.DS,
        '30020026': VR.DS,
        '30020028': VR.DS,
        '30020029': VR.IS,
        '30020030': VR.SQ,
        '30020032': VR.DS,
        '30020034': VR.DS,
        '30020040': VR.SQ,
        '30020041': VR.CS,
        '30020042': VR.DS,
        '30020050': VR.SQ,
        '30020051': VR.CS,
        '30020052': VR.SH,
        '30040001': VR.CS,
        '30040002': VR.CS,
        '30040004': VR.CS,
        '30040005': VR.CS,
        '30040006': VR.LO,
        '30040008': VR.DS,
        '3004000a': VR.CS,
        '3004000c': VR.DS,
        '3004000e': VR.DS,
        '30040010': VR.SQ,
        '30040012': VR.DS,
        '30040014': VR.CS,
        '30040040': VR.DS,
        '30040042': VR.DS,
        '30040050': VR.SQ,
        '30040052': VR.DS,
        '30040054': VR.CS,
        '30040056': VR.IS,
        '30040058': VR.DS,
        '30040060': VR.SQ,
        '30040062': VR.CS,
        '30040070': VR.DS,
        '30040072': VR.DS,
        '30040074': VR.DS,
        '30060002': VR.SH,
        '30060004': VR.LO,
        '30060006': VR.ST,
        '30060008': VR.DA,
        '30060009': VR.TM,
        '30060010': VR.SQ,
        '30060012': VR.SQ,
        '30060014': VR.SQ,
        '30060016': VR.SQ,
        '30060018': VR.SQ,
        '30060020': VR.SQ,
        '30060022': VR.IS,
        '30060024': VR.UI,
        '30060026': VR.LO,
        '30060028': VR.ST,
        '3006002a': VR.IS,
        '3006002c': VR.DS,
        '30060030': VR.SQ,
        '30060033': VR.CS,
        '30060036': VR.CS,
        '30060038': VR.LO,
        '30060039': VR.SQ,
        '30060040': VR.SQ,
        '30060042': VR.CS,
        '30060044': VR.DS,
        '30060045': VR.DS,
        '30060046': VR.IS,
        '30060048': VR.IS,
        '30060049': VR.IS,
        '30060050': VR.DS,
        '30060080': VR.SQ,
        '30060082': VR.IS,
        '30060084': VR.IS,
        '30060085': VR.SH,
        '30060086': VR.SQ,
        '30060088': VR.ST,
        '300600a0': VR.SQ,
        '300600a4': VR.CS,
        '300600a6': VR.PN,
        '300600b0': VR.SQ,
        '300600b2': VR.CS,
        '300600b4': VR.DS,
        '300600b6': VR.SQ,
        '300600b7': VR.US,
        '300600b8': VR.FL,
        '300600b9': VR.SQ,
        '300600c0': VR.SQ,
        '300600c2': VR.UI,
        '300600c4': VR.CS,
        '300600c6': VR.DS,
        '300600c8': VR.LO,
        '30080010': VR.SQ,
        '30080012': VR.ST,
        '30080014': VR.CS,
        '30080016': VR.DS,
        '30080020': VR.SQ,
        '30080021': VR.SQ,
        '30080022': VR.IS,
        '30080024': VR.DA,
        '30080025': VR.TM,
        '3008002a': VR.CS,
        '3008002b': VR.SH,
        '3008002c': VR.CS,
        '30080030': VR.SQ,
        '30080032': VR.DS,
        '30080033': VR.DS,
        '30080036': VR.DS,
        '30080037': VR.DS,
        '3008003a': VR.DS,
        '3008003b': VR.DS,
        '30080040': VR.SQ,
        '30080041': VR.SQ,
        '30080042': VR.DS,
        '30080044': VR.DS,
        '30080045': VR.FL,
        '30080046': VR.FL,
        '30080047': VR.FL,
        '30080048': VR.DS,
        '30080050': VR.SQ,
        '30080052': VR.DS,
        '30080054': VR.DA,
        '30080056': VR.DA,
        '3008005a': VR.IS,
        '30080060': VR.SQ,
        '30080061': VR.AT,
        '30080062': VR.AT,
        '30080063': VR.IS,
        '30080064': VR.IS,
        '30080065': VR.AT,
        '30080066': VR.ST,
        '30080067': VR.US,
        '30080068': VR.SQ,
        '3008006a': VR.FL,
        '30080070': VR.SQ,
        '30080072': VR.IS,
        '30080074': VR.ST,
        '30080076': VR.DS,
        '30080078': VR.DS,
        '3008007a': VR.DS,
        '30080080': VR.SQ,
        '30080082': VR.IS,
        '30080090': VR.SQ,
        '30080092': VR.IS,
        '300800a0': VR.SQ,
        '300800b0': VR.SQ,
        '300800c0': VR.SQ,
        '300800d0': VR.SQ,
        '300800e0': VR.SQ,
        '300800f0': VR.SQ,
        '300800f2': VR.SQ,
        '300800f4': VR.SQ,
        '300800f6': VR.SQ,
        '30080100': VR.SQ,
        '30080105': VR.LO,
        '30080110': VR.SQ,
        '30080116': VR.CS,
        '30080120': VR.SQ,
        '30080122': VR.IS,
        '30080130': VR.SQ,
        '30080132': VR.DS,
        '30080134': VR.DS,
        '30080136': VR.IS,
        '30080138': VR.IS,
        '3008013a': VR.DS,
        '3008013c': VR.DS,
        '30080140': VR.SQ,
        '30080142': VR.IS,
        '30080150': VR.SQ,
        '30080152': VR.IS,
        '30080160': VR.SQ,
        '30080162': VR.DA,
        '30080164': VR.TM,
        '30080166': VR.DA,
        '30080168': VR.TM,
        '30080171': VR.SQ,
        '30080172': VR.US,
        '30080173': VR.SQ,
        '30080200': VR.CS,
        '30080202': VR.ST,
        '30080220': VR.SQ,
        '30080223': VR.IS,
        '30080224': VR.CS,
        '30080230': VR.CS,
        '30080240': VR.SQ,
        '30080250': VR.DA,
        '30080251': VR.TM,
        '300a0002': VR.SH,
        '300a0003': VR.LO,
        '300a0004': VR.ST,
        '300a0006': VR.DA,
        '300a0007': VR.TM,
        '300a0009': VR.LO,
        '300a000a': VR.CS,
        '300a000b': VR.LO,
        '300a000c': VR.CS,
        '300a000e': VR.ST,
        '300a0010': VR.SQ,
        '300a0012': VR.IS,
        '300a0013': VR.UI,
        '300a0014': VR.CS,
        '300a0015': VR.CS,
        '300a0016': VR.LO,
        '300a0018': VR.DS,
        '300a001a': VR.DS,
        '300a0020': VR.CS,
        '300a0021': VR.DS,
        '300a0022': VR.DS,
        '300a0023': VR.DS,
        '300a0025': VR.DS,
        '300a0026': VR.DS,
        '300a0027': VR.DS,
        '300a0028': VR.DS,
        '300a002a': VR.DS,
        '300a002b': VR.DS,
        '300a002c': VR.DS,
        '300a002d': VR.DS,
        '300a0040': VR.SQ,
        '300a0042': VR.IS,
        '300a0043': VR.SH,
        '300a0044': VR.DS,
        '300a0046': VR.DS,
        '300a0048': VR.SQ,
        '300a004a': VR.DS,
        '300a004b': VR.FL,
        '300a004c': VR.DS,
        '300a004e': VR.DS,
        '300a004f': VR.FL,
        '300a0050': VR.FL,
        '300a0051': VR.DS,
        '300a0052': VR.DS,
        '300a0053': VR.DS,
        '300a0055': VR.CS,
        '300a0070': VR.SQ,
        '300a0071': VR.IS,
        '300a0072': VR.LO,
        '300a0078': VR.IS,
        '300a0079': VR.IS,
        '300a007a': VR.IS,
        '300a007b': VR.LT,
        '300a0080': VR.IS,
        '300a0082': VR.DS,
        '300a0083': VR.UI,
        '300a0084': VR.DS,
        '300a0086': VR.DS,
        '300a0088': VR.FL,
        '300a0089': VR.FL,
        '300a008a': VR.FL,
        '300a008b': VR.CS,
        '300a008c': VR.SQ,
        '300a008d': VR.FL,
        '300a008e': VR.FL,
        '300a008f': VR.FL,
        '300a0090': VR.CS,
        '300a0091': VR.DS,
        '300a0092': VR.CS,
        '300a0093': VR.CS,
        '300a00a0': VR.IS,
        '300a00a2': VR.DS,
        '300a00a4': VR.DS,
        '300a00b0': VR.SQ,
        '300a00b2': VR.SH,
        '300a00b3': VR.CS,
        '300a00b4': VR.DS,
        '300a00b6': VR.SQ,
        '300a00b8': VR.CS,
        '300a00ba': VR.DS,
        '300a00bb': VR.FL,
        '300a00bc': VR.IS,
        '300a00be': VR.DS,
        '300a00c0': VR.IS,
        '300a00c2': VR.LO,
        '300a00c3': VR.ST,
        '300a00c4': VR.CS,
        '300a00c5': VR.FD,
        '300a00c6': VR.CS,
        '300a00c7': VR.CS,
        '300a00c8': VR.IS,
        '300a00ca': VR.SQ,
        '300a00cc': VR.LO,
        '300a00ce': VR.CS,
        '300a00d0': VR.IS,
        '300a00d1': VR.SQ,
        '300a00d2': VR.IS,
        '300a00d3': VR.CS,
        '300a00d4': VR.SH,
        '300a00d5': VR.IS,
        '300a00d6': VR.DS,
        '300a00d7': VR.FL,
        '300a00d8': VR.DS,
        '300a00d9': VR.FL,
        '300a00da': VR.DS,
        '300a00db': VR.FL,
        '300a00dc': VR.SH,
        '300a00dd': VR.ST,
        '300a00de': VR.DS,
        '300a00e0': VR.IS,
        '300a00e1': VR.SH,
        '300a00e2': VR.DS,
        '300a00e3': VR.SQ,
        '300a00e4': VR.IS,
        '300a00e5': VR.SH,
        '300a00e6': VR.DS,
        '300a00e7': VR.IS,
        '300a00e8': VR.IS,
        '300a00e9': VR.DS,
        '300a00ea': VR.DS,
        '300a00eb': VR.DS,
        '300a00ec': VR.DS,
        '300a00ed': VR.IS,
        '300a00ee': VR.CS,
        '300a00ef': VR.SH,
        '300a00f0': VR.IS,
        '300a00f2': VR.DS,
        '300a00f3': VR.FL,
        '300a00f4': VR.SQ,
        '300a00f5': VR.SH,
        '300a00f6': VR.DS,
        '300a00f7': VR.FL,
        '300a00f8': VR.CS,
        '300a00f9': VR.LO,
        '300a00fa': VR.CS,
        '300a00fb': VR.CS,
        '300a00fc': VR.IS,
        '300a00fe': VR.LO,
        '300a0100': VR.DS,
        '300a0102': VR.DS,
        '300a0104': VR.IS,
        '300a0106': VR.DS,
        '300a0107': VR.SQ,
        '300a0108': VR.SH,
        '300a0109': VR.CS,
        '300a010a': VR.LO,
        '300a010c': VR.DS,
        '300a010e': VR.DS,
        '300a0110': VR.IS,
        '300a0111': VR.SQ,
        '300a0112': VR.IS,
        '300a0114': VR.DS,
        '300a0115': VR.DS,
        '300a0116': VR.SQ,
        '300a0118': VR.CS,
        '300a011a': VR.SQ,
        '300a011c': VR.DS,
        '300a011e': VR.DS,
        '300a011f': VR.CS,
        '300a0120': VR.DS,
        '300a0121': VR.CS,
        '300a0122': VR.DS,
        '300a0123': VR.CS,
        '300a0124': VR.DS,
        '300a0125': VR.DS,
        '300a0126': VR.CS,
        '300a0128': VR.DS,
        '300a0129': VR.DS,
        '300a012a': VR.DS,
        '300a012c': VR.DS,
        '300a012e': VR.DS,
        '300a0130': VR.DS,
        '300a0131': VR.FL,
        '300a0132': VR.FL,
        '300a0133': VR.FL,
        '300a0134': VR.DS,
        '300a0140': VR.FL,
        '300a0142': VR.CS,
        '300a0144': VR.FL,
        '300a0146': VR.CS,
        '300a0148': VR.FL,
        '300a014a': VR.FL,
        '300a014c': VR.CS,
        '300a014e': VR.FL,
        '300a0150': VR.CS,
        '300a0151': VR.DS,
        '300a0152': VR.DS,
        '300a0153': VR.DS,
        '300a0154': VR.DS,
        '300a0155': VR.DS,
        '300a0180': VR.SQ,
        '300a0182': VR.IS,
        '300a0183': VR.LO,
        '300a0184': VR.LO,
        '300a0190': VR.SQ,
        '300a0192': VR.CS,
        '300a0194': VR.SH,
        '300a0196': VR.ST,
        '300a0198': VR.SH,
        '300a0199': VR.FL,
        '300a019a': VR.FL,
        '300a01a0': VR.SQ,
        '300a01a2': VR.CS,
        '300a01a4': VR.SH,
        '300a01a6': VR.ST,
        '300a01a8': VR.SH,
        '300a01b0': VR.CS,
        '300a01b2': VR.ST,
        '300a01b4': VR.SQ,
        '300a01b6': VR.CS,
        '300a01b8': VR.SH,
        '300a01ba': VR.ST,
        '300a01bc': VR.DS,
        '300a01d0': VR.ST,
        '300a01d2': VR.DS,
        '300a01d4': VR.DS,
        '300a01d6': VR.DS,
        '300a0200': VR.CS,
        '300a0202': VR.CS,
        '300a0206': VR.SQ,
        '300a0210': VR.SQ,
        '300a0212': VR.IS,
        '300a0214': VR.CS,
        '300a0216': VR.LO,
        '300a0218': VR.DS,
        '300a021a': VR.DS,
        '300a021b': VR.SH,
        '300a021c': VR.LO,
        '300a0222': VR.DS,
        '300a0224': VR.DS,
        '300a0226': VR.LO,
        '300a0228': VR.DS,
        '300a0229': VR.CS,
        '300a022a': VR.DS,
        '300a022b': VR.DS,
        '300a022c': VR.DA,
        '300a022e': VR.TM,
        '300a0230': VR.SQ,
        '300a0232': VR.CS,
        '300a0234': VR.IS,
        '300a0236': VR.LO,
        '300a0238': VR.LO,
        '300a0240': VR.IS,
        '300a0242': VR.SH,
        '300a0244': VR.LO,
        '300a0250': VR.DS,
        '300a0260': VR.SQ,
        '300a0262': VR.IS,
        '300a0263': VR.SH,
        '300a0264': VR.CS,
        '300a0266': VR.LO,
        '300a026a': VR.DS,
        '300a026c': VR.DS,
        '300a0271': VR.DS,
        '300a0272': VR.DS,
        '300a0273': VR.SH,
        '300a0274': VR.DS,
        '300a0280': VR.SQ,
        '300a0282': VR.IS,
        '300a0284': VR.DS,
        '300a0286': VR.DS,
        '300a0288': VR.CS,
        '300a028a': VR.IS,
        '300a028c': VR.DS,
        '300a0290': VR.IS,
        '300a0291': VR.SH,
        '300a0292': VR.CS,
        '300a0294': VR.LO,
        '300a0296': VR.DS,
        '300a0298': VR.LO,
        '300a029c': VR.DS,
        '300a029e': VR.DS,
        '300a02a0': VR.DS,
        '300a02a2': VR.IS,
        '300a02a4': VR.DS,
        '300a02b0': VR.SQ,
        '300a02b2': VR.IS,
        '300a02b3': VR.SH,
        '300a02b4': VR.LO,
        '300a02b8': VR.DS,
        '300a02ba': VR.DS,
        '300a02c8': VR.DS,
        '300a02d0': VR.SQ,
        '300a02d2': VR.DS,
        '300a02d4': VR.DS,
        '300a02d6': VR.DS,
        '300a02e0': VR.CS,
        '300a02e1': VR.CS,
        '300a02e2': VR.DS,
        '300a02e3': VR.FL,
        '300a02e4': VR.FL,
        '300a02e5': VR.FL,
        '300a02e6': VR.FL,
        '300a02e7': VR.FL,
        '300a02e8': VR.FL,
        '300a02ea': VR.SQ,
        '300a02eb': VR.LT,
        '300a0302': VR.IS,
        '300a0304': VR.IS,
        '300a0306': VR.SS,
        '300a0308': VR.CS,
        '300a0309': VR.CS,
        '300a030a': VR.FL,
        '300a030c': VR.SQ,
        '300a030d': VR.FL,
        '300a030f': VR.SH,
        '300a0312': VR.IS,
        '300a0314': VR.SQ,
        '300a0316': VR.IS,
        '300a0318': VR.SH,
        '300a0320': VR.CS,
        '300a0322': VR.LO,
        '300a0330': VR.IS,
        '300a0332': VR.SQ,
        '300a0334': VR.IS,
        '300a0336': VR.SH,
        '300a0338': VR.CS,
        '300a033a': VR.LO,
        '300a033c': VR.FL,
        '300a0340': VR.IS,
        '300a0342': VR.SQ,
        '300a0344': VR.IS,
        '300a0346': VR.SH,
        '300a0348': VR.CS,
        '300a034a': VR.LO,
        '300a034c': VR.SH,
        '300a0350': VR.CS,
        '300a0352': VR.SH,
        '300a0354': VR.LO,
        '300a0355': VR.LO,
        '300a0356': VR.FL,
        '300a0358': VR.FL,
        '300a035a': VR.FL,
        '300a0360': VR.SQ,
        '300a0362': VR.LO,
        '300a0364': VR.FL,
        '300a0366': VR.FL,
        '300a0370': VR.SQ,
        '300a0372': VR.LO,
        '300a0374': VR.FL,
        '300a0380': VR.SQ,
        '300a0382': VR.FL,
        '300a0384': VR.FL,
        '300a0386': VR.FL,
        '300a0388': VR.FL,
        '300a038a': VR.FL,
        '300a038f': VR.FL,
        '300a0390': VR.SH,
        '300a0391': VR.IS,
        '300a0392': VR.IS,
        '300a0393': VR.CS,
        '300a0394': VR.FL,
        '300a0395': VR.CS,
        '300a0396': VR.FL,
        '300a0398': VR.FL,
        '300a039a': VR.IS,
        '300a03a0': VR.SQ,
        '300a03a2': VR.SQ,
        '300a03a4': VR.SQ,
        '300a03a6': VR.SQ,
        '300a03a8': VR.SQ,
        '300a03aa': VR.SQ,
        '300a03ac': VR.SQ,
        '300a0401': VR.SQ,
        '300a0402': VR.ST,
        '300a0410': VR.SQ,
        '300a0412': VR.FL,
        '300a0420': VR.SQ,
        '300a0421': VR.SH,
        '300a0422': VR.ST,
        '300a0423': VR.CS,
        '300a0424': VR.IS,
        '300a0425': VR.FL,
        '300a0431': VR.SQ,
        '300a0432': VR.CS,
        '300a0433': VR.FL,
        '300a0434': VR.FL,
        '300a0435': VR.FL,
        '300a0436': VR.FL,
        '300a0440': VR.IS,
        '300a0441': VR.SQ,
        '300a0442': VR.DS,
        '300a0443': VR.US,
        '300a0450': VR.SQ,
        '300a0451': VR.CS,
        '300a0452': VR.CS,
        '300a0453': VR.SQ,
        '300a0501': VR.FL,
        '300a0502': VR.FL,
        '300a0503': VR.FL,
        '300a0504': VR.FL,
        '300a0505': VR.SQ,
        '300a0506': VR.SQ,
        '300a0507': VR.FL,
        '300a0508': VR.FL,
        '300a0509': VR.FL,
        '300a0510': VR.FL,
        '300a0511': VR.CS,
        '300a0512': VR.CS,
        '300c0002': VR.SQ,
        '300c0004': VR.SQ,
        '300c0006': VR.IS,
        '300c0007': VR.IS,
        '300c0008': VR.DS,
        '300c0009': VR.DS,
        '300c000a': VR.SQ,
        '300c000c': VR.IS,
        '300c000e': VR.IS,
        '300c0020': VR.SQ,
        '300c0022': VR.IS,
        '300c0040': VR.SQ,
        '300c0042': VR.SQ,
        '300c0050': VR.SQ,
        '300c0051': VR.IS,
        '300c0055': VR.SQ,
        '300c0060': VR.SQ,
        '300c006a': VR.IS,
        '300c0080': VR.SQ,
        '300c00a0': VR.IS,
        '300c00b0': VR.SQ,
        '300c00c0': VR.IS,
        '300c00d0': VR.IS,
        '300c00e0': VR.IS,
        '300c00f0': VR.IS,
        '300c00f2': VR.SQ,
        '300c00f4': VR.IS,
        '300c00f6': VR.IS,
        '300c0100': VR.IS,
        '300c0102': VR.IS,
        '300c0104': VR.IS,
        '300c0111': VR.SQ,
        '300c0112': VR.CS,
        '300c0113': VR.LO,
        '300e0002': VR.CS,
        '300e0004': VR.DA,
        '300e0005': VR.TM,
        '300e0008': VR.PN,
        '40000010': VR.LT,
        '40004000': VR.LT,
        '40080040': VR.SH,
        '40080042': VR.LO,
        '40080050': VR.SQ,
        '400800ff': VR.CS,
        '40080100': VR.DA,
        '40080101': VR.TM,
        '40080102': VR.PN,
        '40080103': VR.LO,
        '40080108': VR.DA,
        '40080109': VR.TM,
        '4008010a': VR.PN,
        '4008010b': VR.ST,
        '4008010c': VR.PN,
        '40080111': VR.SQ,
        '40080112': VR.DA,
        '40080113': VR.TM,
        '40080114': VR.PN,
        '40080115': VR.LT,
        '40080117': VR.SQ,
        '40080118': VR.SQ,
        '40080119': VR.PN,
        '4008011a': VR.LO,
        '40080200': VR.SH,
        '40080202': VR.LO,
        '40080210': VR.CS,
        '40080212': VR.CS,
        '40080300': VR.ST,
        '40084000': VR.ST,
        '40100001': VR.CS,
        '40100002': VR.CS,
        '40100004': VR.SQ,
        '40101001': VR.SQ,
        '40101004': VR.FL,
        '40101005': VR.FL,
        '40101006': VR.OB,
        '40101007': VR.SH,
        '40101008': VR.CS,
        '40101009': VR.CS,
        '4010100a': VR.SQ,
        '40101010': VR.US,
        '40101011': VR.SQ,
        '40101012': VR.CS,
        '40101013': VR.LT,
        '40101014': VR.CS,
        '40101015': VR.CS,
        '40101016': VR.FL,
        '40101017': VR.FL,
        '40101018': VR.FL,
        '40101019': VR.FL,
        '4010101a': VR.SH,
        '4010101b': VR.FL,
        '4010101c': VR.FL,
        '4010101d': VR.FL,
        '4010101e': VR.SH,
        '4010101f': VR.SH,
        '40101020': VR.CS,
        '40101021': VR.CS,
        '40101023': VR.FL,
        '40101024': VR.CS,
        '40101025': VR.DT,
        '40101026': VR.DT,
        '40101027': VR.CS,
        '40101028': VR.CS,
        '40101029': VR.LO,
        '4010102a': VR.SH,
        '4010102b': VR.DT,
        '40101031': VR.CS,
        '40101033': VR.US,
        '40101034': VR.US,
        '40101037': VR.SQ,
        '40101038': VR.SQ,
        '40101039': VR.CS,
        '4010103a': VR.CS,
        '40101041': VR.DT,
        '40101042': VR.CS,
        '40101043': VR.FL,
        '40101044': VR.CS,
        '40101045': VR.SQ,
        '40101046': VR.CS,
        '40101047': VR.SQ,
        '40101048': VR.CS,
        '40101051': VR.LO,
        '40101052': VR.SH,
        '40101053': VR.LO,
        '40101054': VR.SH,
        '40101055': VR.SH,
        '40101056': VR.CS,
        '40101058': VR.SH,
        '40101059': VR.CS,
        '40101060': VR.FL,
        '40101061': VR.FL,
        '40101062': VR.FL,
        '40101064': VR.SQ,
        '40101067': VR.CS,
        '40101068': VR.LT,
        '40101069': VR.FL,
        '4010106c': VR.OB,
        '4010106d': VR.CS,
        '4010106e': VR.CS,
        '4010106f': VR.SQ,
        '40101070': VR.CS,
        '40101071': VR.SQ,
        '40101072': VR.SQ,
        '40101073': VR.FD,
        '40101075': VR.DS,
        '40101076': VR.SQ,
        '40101077': VR.SQ,
        '40101078': VR.ST,
        '40101079': VR.SQ,
        '4010107a': VR.FL,
        '4010107b': VR.SQ,
        '4010107c': VR.CS,
        '4010107d': VR.SQ,
        '4010107e': VR.DS,
        '4ffe0001': VR.SQ,
        '50000005': VR.US,
        '50000010': VR.US,
        '50000020': VR.CS,
        '50000022': VR.LO,
        '50000030': VR.SH,
        '50000040': VR.SH,
        '50000103': VR.US,
        '50000104': VR.US,
        '50000105': VR.US,
        '50000106': VR.SH,
        '50000110': VR.US,
        '50000112': VR.US,
        '50000114': VR.US,
        '50001001': VR.CS,
        '50002000': VR.US,
        '50002002': VR.US,
        '50002004': VR.US,
        '50002006': VR.UL,
        '50002008': VR.UL,
        '5000200a': VR.UL,
        '5000200c': VR.OW,
        '5000200e': VR.LT,
        '50002500': VR.LO,
        '50002600': VR.SQ,
        '50002610': VR.US,
        '50003000': VR.OW,
        '52009229': VR.SQ,
        '52009230': VR.SQ,
        '54000100': VR.SQ,
        '54000110': VR.OW,
        '54000112': VR.OW,
        '54001004': VR.US,
        '54001006': VR.CS,
        '5400100a': VR.OW,
        '54001010': VR.OW,
        '56000010': VR.OF,
        '56000020': VR.OF,
        '60000010': VR.US,
        '60000011': VR.US,
        '60000012': VR.US,
        '60000015': VR.IS,
        '60000022': VR.LO,
        '60000040': VR.CS,
        '60000045': VR.LO,
        '60000050': VR.SS,
        '60000051': VR.US,
        '60000052': VR.US,
        '60000060': VR.CS,
        '60000061': VR.SH,
        '60000062': VR.SH,
        '60000063': VR.CS,
        '60000066': VR.AT,
        '60000068': VR.US,
        '60000069': VR.US,
        '60000100': VR.US,
        '60000102': VR.US,
        '60000110': VR.CS,
        '60000200': VR.US,
        '60000800': VR.CS,
        '60000802': VR.US,
        '60000803': VR.AT,
        '60000804': VR.US,
        '60001001': VR.CS,
        '60001100': VR.US,
        '60001101': VR.US,
        '60001102': VR.US,
        '60001103': VR.US,
        '60001200': VR.US,
        '60001201': VR.US,
        '60001202': VR.US,
        '60001203': VR.US,
        '60001301': VR.IS,
        '60001302': VR.DS,
        '60001303': VR.DS,
        '60001500': VR.LO,
        '60003000': VR.OW,
        '60004000': VR.LT,
        '7f000010': VR.OW,
        '7f000011': VR.US,
        '7f000020': VR.OW,
        '7f000030': VR.OW,
        '7f000040': VR.OW,
        '7fe00008': VR.OF,
        '7fe00009': VR.OD,
        '7fe00010': VR.OW,
        '7fe00020': VR.OW,
        '7fe00030': VR.OW,
        '7fe00040': VR.OW,
        fffafffa: VR.SQ,
        fffcfffc: VR.OB,
    };
}
